import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, isRef as _isRef, withKeys as _withKeys, vShow as _vShow } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "cdr-strip-badge"
}
const _hoisted_3 = { class: "cdr-av-list-wrap" }
const _hoisted_4 = ["onClick", "onMouseenter"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "cdr-av-unread-badge"
}
const _hoisted_8 = {
  key: 1,
  class: "cdr-av-snooze-badge"
}
const _hoisted_9 = {
  key: 0,
  class: "cdr-strip-empty"
}
const _hoisted_10 = {
  key: 0,
  class: "cdr-strip-footer-badge"
}
const _hoisted_11 = { class: "cdr-ttc-head" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "cdr-ttc-headinfo" }
const _hoisted_15 = { class: "cdr-ttc-row1" }
const _hoisted_16 = { class: "cdr-ttc-name" }
const _hoisted_17 = {
  key: 0,
  class: "cdr-ttc-unread"
}
const _hoisted_18 = { class: "cdr-ttc-id" }
const _hoisted_19 = { class: "cdr-ttc-body" }
const _hoisted_20 = {
  key: 0,
  class: "cdr-ttc-row cdr-ttc-row--phone"
}
const _hoisted_21 = {
  key: 1,
  class: "cdr-ttc-row"
}
const _hoisted_22 = {
  key: 2,
  class: "cdr-ttc-row"
}
const _hoisted_23 = { class: "cdr-ttc-status" }
const _hoisted_24 = { class: "cdr-tt-head" }
const _hoisted_25 = ["src", "alt"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "cdr-tt-head-info" }
const _hoisted_28 = { class: "cdr-tt-name" }
const _hoisted_29 = {
  key: 0,
  class: "cdr-tt-company"
}
const _hoisted_30 = {
  key: 1,
  class: "cdr-tt-company",
  style: {"opacity":".4"}
}
const _hoisted_31 = {
  key: 0,
  class: "cdr-tt-row"
}
const _hoisted_32 = {
  key: 1,
  class: "cdr-tt-row"
}
const _hoisted_33 = {
  key: 2,
  class: "cdr-tt-row"
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 3,
  class: "cdr-tt-bio"
}
const _hoisted_36 = {
  key: 4,
  class: "cdr-tt-socials"
}
const _hoisted_37 = ["href", "title"]
const _hoisted_38 = {
  key: 5,
  class: "cdr-tt-row"
}
const _hoisted_39 = {
  key: 6,
  class: "cdr-tt-row"
}
const _hoisted_40 = {
  key: 7,
  class: "cdr-tt-lbls"
}
const _hoisted_41 = { class: "cdr-tt-footer" }
const _hoisted_42 = {
  key: 0,
  class: "cdr-tt-unread"
}
const _hoisted_43 = { class: "cdr-head" }
const _hoisted_44 = { class: "cdr-head-title" }
const _hoisted_45 = { class: "cdr-head-badge" }
const _hoisted_46 = ["title"]
const _hoisted_47 = {
  key: 0,
  class: "cdr-search"
}
const _hoisted_48 = {
  key: 1,
  class: "cdr-empty"
}
const _hoisted_49 = {
  key: 2,
  class: "cdr-empty"
}
const _hoisted_50 = {
  key: 3,
  class: "cdr-list"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "cdr-item-av-wrap" }
const _hoisted_54 = ["src", "alt"]
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "cdr-item-body" }
const _hoisted_57 = { class: "cdr-item-r1" }
const _hoisted_58 = ["title"]
const _hoisted_59 = { class: "cdr-item-name" }
const _hoisted_60 = { class: "cdr-item-time" }
const _hoisted_61 = { class: "cdr-item-r2" }
const _hoisted_62 = { class: "cdr-item-preview" }
const _hoisted_63 = {
  key: 0,
  class: "cdr-unread"
}
const _hoisted_64 = {
  key: 0,
  class: "cdr-item-lbls"
}
const _hoisted_65 = {
  key: 1,
  class: "cdr-item-assignee"
}
const _hoisted_66 = {
  key: 2,
  class: "cdr-item-assignee cdr-item-assignee--none"
}
const _hoisted_67 = {
  key: 3,
  class: "cdr-item-fluxo"
}
const _hoisted_68 = { class: "cdr-head" }
const _hoisted_69 = {
  class: "cdr-item-av-wrap",
  style: {"margin":"0 3px 0 4px","position":"relative","flex-shrink":"0"}
}
const _hoisted_70 = ["src", "alt"]
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { class: "cdr-chat-hinfo" }
const _hoisted_73 = { class: "cdr-chat-hname-row" }
const _hoisted_74 = { class: "cdr-chat-hname" }
const _hoisted_75 = {
  key: 0,
  class: "cdr-chat-hphone"
}
const _hoisted_76 = ["title"]
const _hoisted_77 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_78 = {
  key: 1,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_79 = {
  key: 0,
  class: "cdr-chat-hdoc"
}
const _hoisted_80 = { class: "cdr-chat-hsub" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = {
  key: 1,
  class: "cdr-fluxo-tag"
}
const _hoisted_83 = {
  key: 3,
  class: "cdr-agent-tag"
}
const _hoisted_84 = ["title"]
const _hoisted_85 = {
  key: 0,
  class: "cdr-status-menu"
}
const _hoisted_86 = {
  key: 1,
  class: "cdr-snz"
}
const _hoisted_87 = { class: "cdr-snz-row" }
const _hoisted_88 = { class: "cdr-snz-btns" }
const _hoisted_89 = ["disabled"]
const _hoisted_90 = ["disabled", "title"]
const _hoisted_91 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_92 = {
  key: 1,
  class: "cdr-spinner",
  style: {"width":"10px","height":"10px","border-width":"2px"}
}
const _hoisted_93 = ["title"]
const _hoisted_94 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_95 = {
  key: 1,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_96 = { class: "cdr-chat-lbls" }
const _hoisted_97 = {
  key: 2,
  class: "cdr-agent-menu"
}
const _hoisted_98 = { class: "cdr-agent-search-wrap" }
const _hoisted_99 = {
  key: 0,
  style: {"padding":"12px","display":"flex","justify-content":"center"}
}
const _hoisted_100 = {
  key: 1,
  class: "cdr-agent-list"
}
const _hoisted_101 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e","flex-shrink":"0"}
}
const _hoisted_102 = ["onClick"]
const _hoisted_103 = ["title"]
const _hoisted_104 = ["src", "alt"]
const _hoisted_105 = { key: 1 }
const _hoisted_106 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e","flex-shrink":"0"}
}
const _hoisted_107 = {
  key: 2,
  class: "cdr-agent-menu"
}
const _hoisted_108 = { class: "cdr-agent-search-wrap" }
const _hoisted_109 = {
  key: 0,
  style: {"padding":"12px","display":"flex","justify-content":"center"}
}
const _hoisted_110 = {
  key: 1,
  class: "cdr-agent-list"
}
const _hoisted_111 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e","flex-shrink":"0"}
}
const _hoisted_112 = ["onClick"]
const _hoisted_113 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e","flex-shrink":"0"}
}
const _hoisted_114 = ["title"]
const _hoisted_115 = {
  width: "8",
  height: "8",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  style: {"flex-shrink":"0"}
}
const _hoisted_116 = {
  key: 0,
  class: "cdr-p-spin"
}
const _hoisted_117 = ["disabled"]
const _hoisted_118 = {
  key: 0,
  width: "8",
  height: "8",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_119 = {
  key: 1,
  class: "cdr-p-spin"
}
const _hoisted_120 = {
  key: 2,
  class: "cdr-priority-menu"
}
const _hoisted_121 = ["onClick"]
const _hoisted_122 = {
  key: 1,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_123 = {
  key: 2,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e","flex-shrink":"0"}
}
const _hoisted_124 = ["onClick", "disabled"]
const _hoisted_125 = {
  key: 1,
  class: "cdr-lbl-lock",
  width: "9",
  height: "9",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  title: "Etiqueta protegida — não pode ser removida"
}
const _hoisted_126 = { class: "cdr-lbl-picker" }
const _hoisted_127 = ["disabled"]
const _hoisted_128 = {
  key: 0,
  class: "cdr-lbl-dropdown"
}
const _hoisted_129 = {
  key: 0,
  class: "cdr-lbl-loading"
}
const _hoisted_130 = ["onClick"]
const _hoisted_131 = { class: "cdr-lbl-opt-name" }
const _hoisted_132 = {
  key: 0,
  width: "11",
  height: "11",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"var(--ink-40)","flex-shrink":"0"},
  title: "Etiqueta protegida — não pode ser removida"
}
const _hoisted_133 = {
  key: 1,
  width: "11",
  height: "11",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e","flex-shrink":"0"}
}
const _hoisted_134 = {
  key: 0,
  class: "cdr-snooze-banner"
}
const _hoisted_135 = { key: 0 }
const _hoisted_136 = { key: 1 }
const _hoisted_137 = {
  key: 1,
  class: "cdr-window-banner"
}
const _hoisted_138 = {
  key: 2,
  class: "cdr-msg-search-bar"
}
const _hoisted_139 = {
  key: 0,
  class: "cdr-msg-search-count"
}
const _hoisted_140 = {
  key: 3,
  class: "cdr-macro-panel"
}
const _hoisted_141 = { class: "cdr-macro-head" }
const _hoisted_142 = { class: "cdr-macro-run-title" }
const _hoisted_143 = { class: "cdr-macro-form" }
const _hoisted_144 = { class: "cdr-mform-card-header" }
const _hoisted_145 = { class: "cdr-mform-num" }
const _hoisted_146 = { class: "cdr-mform-card-info" }
const _hoisted_147 = {
  key: 0,
  class: "cdr-mform-card-url"
}
const _hoisted_148 = { class: "cdr-mform-label" }
const _hoisted_149 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_150 = { class: "cdr-macro-head" }
const _hoisted_151 = { class: "cdr-macro-search-wrap" }
const _hoisted_152 = { class: "cdr-macro-count" }
const _hoisted_153 = {
  key: 0,
  class: "cdr-macro-loading"
}
const _hoisted_154 = {
  key: 1,
  class: "cdr-macro-list"
}
const _hoisted_155 = ["onClick"]
const _hoisted_156 = { class: "cdr-macro-item-body" }
const _hoisted_157 = { class: "cdr-macro-item-name" }
const _hoisted_158 = { class: "cdr-macro-item-sub" }
const _hoisted_159 = {
  key: 0,
  class: "cdr-macro-empty"
}
const _hoisted_160 = { class: "cdr-macro-head" }
const _hoisted_161 = { class: "cdr-macro-run-title" }
const _hoisted_162 = {
  key: 1,
  class: "cdr-spinner",
  style: {"width":"12px","height":"12px","border-width":"2px","flex-shrink":"0"}
}
const _hoisted_163 = { class: "cdr-macro-steps" }
const _hoisted_164 = {
  key: 0,
  width: "11",
  height: "11",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_165 = {
  key: 1,
  width: "11",
  height: "11",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_166 = { class: "cdr-macro-step-label" }
const _hoisted_167 = {
  key: 2,
  class: "cdr-macro-step-msg"
}
const _hoisted_168 = {
  key: 0,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_169 = {
  key: 1,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_170 = {
  key: 0,
  class: "cdr-msgs-loading"
}
const _hoisted_171 = {
  key: 1,
  class: "cdr-msg-skeleton"
}
const _hoisted_172 = {
  key: 0,
  class: "cdr-load-more-row"
}
const _hoisted_173 = {
  key: 1,
  class: "cdr-no-more"
}
const _hoisted_174 = ["data-msg-id"]
const _hoisted_175 = {
  key: 0,
  class: "cdr-msg-act"
}
const _hoisted_176 = ["title"]
const _hoisted_177 = ["src", "alt"]
const _hoisted_178 = { key: 1 }
const _hoisted_179 = {
  key: 1,
  class: "cdr-msg-av-spacer"
}
const _hoisted_180 = {
  key: 0,
  class: "cdr-priv-tag"
}
const _hoisted_181 = ["innerHTML"]
const _hoisted_182 = ["href"]
const _hoisted_183 = ["href"]
const _hoisted_184 = ["src"]
const _hoisted_185 = {
  key: 1,
  class: "cdr-ap"
}
const _hoisted_186 = ["onClick"]
const _hoisted_187 = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_188 = {
  key: 1,
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_189 = { class: "cdr-ap-mid" }
const _hoisted_190 = ["value", "onInput"]
const _hoisted_191 = { class: "cdr-ap-time" }
const _hoisted_192 = ["href"]
const _hoisted_193 = {
  key: 2,
  class: "cdr-att-video-wrap"
}
const _hoisted_194 = ["src"]
const _hoisted_195 = ["href"]
const _hoisted_196 = { class: "cdr-att-file-info" }
const _hoisted_197 = { class: "cdr-att-file-size" }
const _hoisted_198 = ["href"]
const _hoisted_199 = { class: "cdr-att-file-info" }
const _hoisted_200 = { class: "cdr-att-file-ext" }
const _hoisted_201 = { class: "cdr-att-file-size" }
const _hoisted_202 = { class: "cdr-bubble-ts" }
const _hoisted_203 = ["title"]
const _hoisted_204 = {
  key: 0,
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round"
}
const _hoisted_205 = {
  key: 1,
  width: "14",
  height: "8",
  viewBox: "0 0 14 8",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_206 = {
  key: 2,
  width: "10",
  height: "8",
  viewBox: "0 0 10 8",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_207 = {
  key: 4,
  class: "cdr-files"
}
const _hoisted_208 = { class: "cdr-file-name" }
const _hoisted_209 = ["onClick"]
const _hoisted_210 = ["disabled"]
const _hoisted_211 = ["disabled", "title"]
const _hoisted_212 = ["placeholder", "disabled"]
const _hoisted_213 = ["disabled"]
const _hoisted_214 = {
  key: 0,
  class: "cdr-spinner-sm-white"
}
const _hoisted_215 = {
  key: 1,
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_216 = {
  key: 6,
  class: "cdr-recording"
}
const _hoisted_217 = { class: "cdr-rec-wave" }
const _hoisted_218 = { class: "cdr-rec-time" }
const _hoisted_219 = {
  key: 7,
  class: "cdr-rec-preview"
}
const _hoisted_220 = ["src"]
const _hoisted_221 = {
  key: 8,
  class: "cdr-vrec-wrap"
}
const _hoisted_222 = { class: "cdr-vrec-bar" }
const _hoisted_223 = {
  class: "cdr-rec-time",
  style: {"flex":"1","text-align":"left"}
}
const _hoisted_224 = {
  key: 9,
  class: "cdr-vrec-wrap"
}
const _hoisted_225 = ["src"]
const _hoisted_226 = { class: "cdr-tpl-dialog" }
const _hoisted_227 = { class: "cdr-tpl-head" }
const _hoisted_228 = { class: "cdr-tpl-title" }
const _hoisted_229 = { class: "cdr-tpl-contact-name" }
const _hoisted_230 = { class: "cdr-tpl-body" }
const _hoisted_231 = { class: "cdr-tpl-list-col" }
const _hoisted_232 = {
  key: 0,
  class: "cdr-tpl-loading"
}
const _hoisted_233 = {
  key: 1,
  class: "cdr-tpl-loading"
}
const _hoisted_234 = {
  key: 2,
  class: "cdr-tpl-items"
}
const _hoisted_235 = ["onClick"]
const _hoisted_236 = { class: "cdr-tpl-item-name" }
const _hoisted_237 = { class: "cdr-tpl-item-meta" }
const _hoisted_238 = { class: "cdr-tpl-lang" }
const _hoisted_239 = { class: "cdr-tpl-config-col" }
const _hoisted_240 = {
  key: 0,
  class: "cdr-tpl-pick-hint"
}
const _hoisted_241 = { class: "cdr-tpl-preview-wrap" }
const _hoisted_242 = { class: "cdr-tpl-bubble" }
const _hoisted_243 = {
  key: 0,
  class: "cdr-tpl-bubble-img"
}
const _hoisted_244 = ["src"]
const _hoisted_245 = {
  key: 1,
  class: "cdr-tpl-img-ph"
}
const _hoisted_246 = {
  key: 1,
  class: "cdr-tpl-bubble-hdr"
}
const _hoisted_247 = ["innerHTML"]
const _hoisted_248 = {
  key: 2,
  class: "cdr-tpl-bubble-ftr"
}
const _hoisted_249 = { class: "cdr-tpl-bubble-time" }
const _hoisted_250 = {
  key: 0,
  class: "cdr-tpl-btns"
}
const _hoisted_251 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_252 = {
  key: 1,
  style: {"margin-top":"12px"}
}
const _hoisted_253 = { class: "cdr-tpl-field-lbl" }
const _hoisted_254 = {
  key: 0,
  class: "cdr-tpl-mapped-badge"
}
const _hoisted_255 = ["placeholder", "value", "onInput"]
const _hoisted_256 = { style: {"margin-top":"16px"} }
const _hoisted_257 = {
  key: 0,
  class: "cdr-tpl-blocked-hint"
}
const _hoisted_258 = ["disabled", "title"]
const _hoisted_259 = { key: 0 }
const _hoisted_260 = {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"vertical-align":"-2px","margin-right":"5px"}
}
const _hoisted_261 = {
  key: 1,
  class: "cdr-tpl-spin",
  style: {"border-top-color":"#fff","border-color":"rgba(255,255,255,.3)"}
}

import { ref, computed, nextTick, watch, onMounted, onUnmounted, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import type { Conversation } from '@/types/dashboard'
import { avatarColor, initials, fluxoLabel, conversationDocument, isFluxoGeral, confirmAssignDuringFluxoGeral, confirmResolveConversation } from '@/composables/useHelpers'
import { fmtPhone } from '@/utils/contactsFormat'
import { pendingChatId, currentOpenConvId, closeDrawerSignal, focusReplySignal, openMyConvsSignal, activeConvContext } from '@/composables/useChatTrigger'
import { useFloatChats } from '@/composables/useFloatChats'
import { useChatRailMode } from '@/composables/useChatRailMode'
import { useAgentChat } from '@/composables/useAgentChat'
import { usePermission } from '@/composables/usePermission'
import { useSLA } from '@/composables/useSLA'
import { useConversationStore } from '@/composables/useConversationStore'
import { useMyConversations } from '@/composables/useMyConversations'
import { fetchConversationById } from '@/services/conversationService'
import Swal from 'sweetalert2'
import EmojiPicker from '@/components/dashboard/EmojiPicker.vue'
import { n8nDownloadUrl } from '@/api/n8n'
import { snoozeConversation } from '@/services/snoozeService'
import { listMacros, type MacroAction } from '@/services/macrosService'
import { listTeams, listTeamMembersOrAgents, type TeamItem } from '@/services/teamsService'
import {
  toggleConversationStatus, assignAgentViaSystem, assignTeam, logManualAssignment,
  fetchAccountLabels, setConversationLabels, fetchConversation,
} from '@/services/conversationActionsService'
import { runMacroAction, resolveConversationSmart, type MacroActionContext } from '@/services/macroEngineService'
import { isLabelProtected } from '@/composables/useProtectedLabels'
import { fetchMessages, fetchOlderMessages } from '@/services/messagesService'
import { useMessageCache } from '@/composables/useMessageCache'
import { onConversationMessage } from '@/composables/useChatwootMessageRealtime'
import { useMessageSearch } from '@/composables/useMessageSearch'
import { getFileType, isVideo, isPdf, fmtSize, extractFileKey } from '@/composables/useMediaHelpers'
import { useAudioRecorder } from '@/composables/useAudioRecorder'
import { useWhatsappTemplates } from '@/composables/useWhatsappTemplates'
import { useMessageSender } from '@/composables/useMessageSender'
import { useMessageWindow } from '@/composables/useMessageWindow'
import { CHATWOOT_BASE, authHeaders } from '@/api/chatwoot'
import { fetchConversationMessagesForExportApi } from '@/services/contactsService'
import { buildConvHtml, downloadHtmlFile } from '@/utils/contactsExport'
import type { ChatMessage, ProcessedMsg, LabelItem, AgentItem, Priority, SLABadge } from '@/types/chat'
import { PRIORITY_LABELS, PRIORITY_COLORS } from '@/types/chat'
import { allAgents } from '@/composables/useDashboardEngine'
import { playNotificationSound } from '@/composables/useNotificationSound'

interface ContactDetail {
  id: number
  name: string
  email?: string
  phone_number?: string
  thumbnail?: string
  availability_status?: string
  additional_attributes?: {
    city?: string
    country?: string
    description?: string
    company_name?: string
    social_profiles?: {
      instagram?: string
      twitter?: string
      facebook?: string
      linkedin?: string
      telegram?: string
      tiktok?: string
      github?: string
    }
  }
  contact_inboxes?: Array<{
    source_id: string
    inbox: { id: number; name: string; channel_type: string; avatar_url?: string }
  }>
}

const STRIP_W = 60
const MIN_W   = 260
const MAX_W   = 640
interface CdrMacroItem { id: string; name: string; actions: MacroAction[]; team_ids: number[]; is_active: boolean }


export default /*@__PURE__*/_defineComponent({
  __name: 'ConvDrawer',
  setup(__props) {

const { open: floatOpen } = useFloatChats()
const { mode: railMode, toggle: toggleRailMode } = useChatRailMode()
const { totalUnread: agentChatUnread } = useAgentChat()

const store       = useStore()
const route       = useRoute()
const authUser    = computed(() => store.getters.authUser)
const isAdmin     = computed(() => store.getters.isAdmin)
// O Modo Foco (/foco) já cobre "minhas conversas" na própria página — o rail flutuante
// fica escondido lá pra não ter duas fontes de "conversa atual" competindo na tela.
const hiddenOnFoco = computed(() => route.name === 'foco')

const { can, allowedTeamIds } = usePermission()

/* ── Conversations (internal fetch) ──────── */
const { conversations } = useConversationStore()



/* ── Auto-abrir + badge local ────────────── */
const autoOpen         = ref(localStorage.getItem('cdr_auto_open') === 'true')
const prevUnreadMap    = reactive<Record<number, number>>({})
const localReadConvIds = reactive<Set<number>>(new Set())

watch(autoOpen, (val) => {
  localStorage.setItem('cdr_auto_open', val ? 'true' : 'false')
  conversations.value.forEach(c => { prevUnreadMap[c.id] = c.unread_count })
})

watch(conversations, (newConvs) => {
  newConvs.forEach(conv => {
    const tracked = conv.id in prevUnreadMap
    const prev    = prevUnreadMap[conv.id] ?? conv.unread_count

    // Novo mensagem do cliente: contagem aumentou
    if (tracked && conv.unread_count > prev) {
      localReadConvIds.delete(conv.id)           // badge volta a aparecer
      if (autoOpen.value && myConvs.value.some(c => c.id === conv.id)) {
        floatOpen(conv)
      }
    }

    // Servidor zerou unread (ex: agente enviou via Chatwoot): limpa local também
    if (conv.unread_count === 0) {
      localReadConvIds.delete(conv.id)
    }

    prevUnreadMap[conv.id] = conv.unread_count
  })
}, { deep: true })

/* ── Status change state ─────────────────── */
const cdrStatusMenuOpen = ref(false)
const cdrSnoozeMode     = ref(false)
const cdrSnoozeH        = ref(1)
const cdrSnoozeM        = ref(0)
const cdrStatusLoading  = ref(false)
const cdrNowSec         = ref(Math.floor(Date.now() / 1000))

/* ── State ───────────────────────────────── */
const listOpen    = ref(false)
const chatOpen    = ref(false)
const selConvId   = ref<number | null>(null)
// Singleton de módulo (useMessageCache.ts) — compartilhado com FocoView.vue,
// MobileView.vue e FloatChatWindow.vue, pra mesma conversa aberta em mais de
// um lugar não buscar o histórico 2x.
const { msgCache } = useMessageCache()
const loadingMsgs = ref(false)
const loadingMore = ref(false)
const noMoreMsgs  = ref(false)
const draft       = ref('')
const files       = ref<File[]>([])
const notaInterna = ref(false)
const msgsEl      = ref<HTMLElement | null>(null)
const taEl        = ref<HTMLTextAreaElement | null>(null)
const fileInputEl = ref<HTMLInputElement | null>(null)
const stripListEl = ref<HTMLElement | null>(null)

/* ── Scroll do trilho de avatares (setas) ──────────────────────────
   A lista já era scrollável (overflow-y: auto), só não tinha nenhum indício
   visual disso — com mais conversas do que cabem no trilho, dava pra achar
   que só as visíveis existiam (mesmo padrão de AgentChatDrawer.vue). */
const canScrollUp   = ref(false)
const canScrollDown = ref(false)

function updateStripScrollState() {
  const el = stripListEl.value
  if (!el) { canScrollUp.value = false; canScrollDown.value = false; return }
  canScrollUp.value   = el.scrollTop > 4
  canScrollDown.value = el.scrollTop + el.clientHeight < el.scrollHeight - 4
}

function scrollStrip(dir: 1 | -1) {
  stripListEl.value?.scrollBy({ top: dir * 120, behavior: 'smooth' })
}

/* ── Prioridade ───────────────────────────── */
const priorityMenuOpen = ref(false)
const priorityLoading  = ref(false)
const convPriority     = reactive<Record<number, Priority>>({})

const currentPriority = computed<Priority | null>(() => {
  if (!selConvId.value) return null
  const local = convPriority[selConvId.value]
  if (local !== undefined) return local === 'none' ? null : local
  const p = activeConv.value?.priority
  return (p && p !== 'none') ? (p as Priority) : null
})

async function doTogglePriority(priority: Priority) {
  if (!selConvId.value || priorityLoading.value) return
  const convId = selConvId.value
  priorityMenuOpen.value = false
  priorityLoading.value = true
  const prev = convPriority[convId]
  convPriority[convId] = priority
  try {
    const res = await fetch(`${API}/conversations/${convId}/toggle_priority`, {
      method: 'POST',
      headers: { ...apiHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ priority }),
    })
    if (!res.ok) {
      if (prev !== undefined) convPriority[convId] = prev
      else delete convPriority[convId]
    }
  } catch (e) {
    console.error('[ConvDrawer] priority:', e)
    if (prev !== undefined) convPriority[convId] = prev
    else delete convPriority[convId]
  } finally {
    priorityLoading.value = false
  }
}

function onPriorityDocClick(e: MouseEvent) {
  const el = document.querySelector('.cdr-priority-wrap')
  if (el && !el.contains(e.target as Node)) priorityMenuOpen.value = false
}

watch(priorityMenuOpen, open => {
  if (open) setTimeout(() => document.addEventListener('click', onPriorityDocClick), 0)
  else document.removeEventListener('click', onPriorityDocClick)
})

/* ── Atribuição de agente ───────────────────────────── */
const agentMenuOpen  = ref(false)
const agentLoading   = ref(false)
const teamAgents     = ref<AgentItem[]>([])
const agentSearch    = ref('')
const convAssignee   = reactive<Record<number, { id: number; name: string; thumbnail: string } | null>>({})
let   _agentsFetched = false

// Status (agent_status) pra bolinha no avatar da lista — mesma fonte usada em
// TeamMembersModal.vue, não o availability_status do Chatwoot (ver useAvailability.ts).
const agentStatusByUser = ref<Record<number, string>>({})

const filteredAgents = computed(() => {
  const q = agentSearch.value.toLowerCase().trim()
  return q ? teamAgents.value.filter(a => a.name.toLowerCase().includes(q)) : teamAgents.value
})

const currentAssignee = computed(() => {
  if (!selConvId.value) return null
  const convId = selConvId.value
  if (convId in convAssignee) return convAssignee[convId]
  return activeConv.value?.assignee ?? null
})

function agentStatusOf(userId: number): string {
  return agentStatusByUser.value[userId] ?? 'offline'
}

function availLabel(status: string): string {
  return { online: 'Online', busy: 'Ocupado', offline: 'Offline' }[status] ?? 'Offline'
}

// Traz todos os agentes da conta (não só os do time da conversa) — o supervisor
// pode precisar atribuir a qualquer agente, independente do time atual.
// Status de disponibilidade vem de allAgents (useDashboardEngine) — já mantido
// por loadData() a cada ciclo (login/Atualizar/fim do countdown); list_agent_status
// não é mais chamado à parte aqui (ver useDashboardEngine.loadData()).
async function fetchAgents() {
  if (agentLoading.value || _agentsFetched) return
  _agentsFetched = true
  agentLoading.value = true
  try {
    teamAgents.value = await listTeamMembersOrAgents(authUser.value?.access_token || '', null)
    agentStatusByUser.value = Object.fromEntries(
      allAgents.value.map(a => [a.id, a.availability_status])
    )
  } catch {
    _agentsFetched = false
  } finally {
    agentLoading.value = false
  }
}

async function doAssignAgent(agentId: number | null) {
  if (!selConvId.value) return
  const convId = selConvId.value
  if (agentId && isFluxoGeral(activeConv.value?.fluxo_id)) {
    if (!(await confirmAssignDuringFluxoGeral())) return
  }
  agentMenuOpen.value = false
  agentSearch.value = ''
  const agent = agentId ? teamAgents.value.find(a => a.id === agentId) : null
  const prev = convAssignee[convId] !== undefined ? convAssignee[convId] : (activeConv.value?.assignee ?? null)
  convAssignee[convId] = agent ? { id: agent.id, name: agent.name, thumbnail: agent.thumbnail } : null
  const idx = conversations.value.findIndex(c => c.id === convId)
  if (idx !== -1) conversations.value[idx] = {
    ...conversations.value[idx],
    assignee: agent ? { id: agent.id, name: agent.name, email: '', role: 'agent', thumbnail: agent.thumbnail, availability: 'online' } : null,
  }
  try {
    const ok = await assignAgentViaSystem(convId, agentId)
    if (!ok) {
      convAssignee[convId] = prev
      if (idx !== -1) conversations.value[idx] = { ...conversations.value[idx], assignee: (prev as any) }
    } else if (agent && idx !== -1 && authUser.value) {
      logManualAssignment(convId, agent.id, agent.name, conversations.value[idx].contact.name, authUser.value.id, authUser.value.name)
    }
  } catch {
    convAssignee[convId] = prev
    if (idx !== -1) conversations.value[idx] = { ...conversations.value[idx], assignee: (prev as any) }
  }
}

function onAgentDocClick() { agentMenuOpen.value = false; agentSearch.value = '' }
watch(agentMenuOpen, open => {
  if (open) { fetchAgents(); setTimeout(() => document.addEventListener('click', onAgentDocClick), 0) }
  else document.removeEventListener('click', onAgentDocClick)
})

/* ── Atribuição de time ───────────────────── */
const cdrTeamMenuOpen  = ref(false)
const cdrTeamsLoading  = ref(false)
const cdrTeamsList     = ref<TeamItem[]>([])
const cdrTeamSearch    = ref('')
const convTeam         = reactive<Record<number, TeamItem | null>>({})
let   _cdrTeamsFetched = false

const canAssignTeam = computed(() => can('messages.assignTeam'))

const filteredCdrTeams = computed(() => {
  const allowed = allowedTeamIds()
  let list = allowed !== null ? cdrTeamsList.value.filter(t => allowed.includes(t.id)) : cdrTeamsList.value
  const q = cdrTeamSearch.value.toLowerCase().trim()
  return q ? list.filter(t => t.name.toLowerCase().includes(q)) : list
})

const currentTeam = computed<TeamItem | null>(() => {
  if (!selConvId.value) return null
  const convId = selConvId.value
  if (convId in convTeam) return convTeam[convId]
  return activeConv.value?.team ?? null
})

async function fetchCdrTeams() {
  if (_cdrTeamsFetched) return
  cdrTeamsLoading.value = true
  try {
    cdrTeamsList.value = await listTeams(authUser.value?.access_token || '')
    _cdrTeamsFetched = true
  } catch { /* silencioso */ } finally {
    cdrTeamsLoading.value = false
  }
}

async function doAssignCdrTeam(teamId: number | null) {
  if (!selConvId.value) return
  const convId = selConvId.value
  cdrTeamMenuOpen.value = false
  cdrTeamSearch.value = ''
  const team = teamId ? cdrTeamsList.value.find(t => t.id === teamId) : null
  const prev = convTeam[convId] !== undefined ? convTeam[convId] : (activeConv.value?.team ?? null)
  convTeam[convId] = team ?? null
  const idx = conversations.value.findIndex(c => c.id === convId)
  if (idx !== -1) conversations.value[idx] = { ...conversations.value[idx], team: team ?? null }
  try {
    const ok = await assignTeam(convId, authUser.value?.access_token || '', teamId)
    if (!ok) {
      convTeam[convId] = prev
      if (idx !== -1) conversations.value[idx] = { ...conversations.value[idx], team: (prev as any) }
    }
  } catch {
    convTeam[convId] = prev
    if (idx !== -1) conversations.value[idx] = { ...conversations.value[idx], team: (prev as any) }
  }
}

function onCdrTeamDocClick() { cdrTeamMenuOpen.value = false; cdrTeamSearch.value = '' }
watch(cdrTeamMenuOpen, open => {
  if (open) { fetchCdrTeams(); setTimeout(() => document.addEventListener('click', onCdrTeamDocClick), 0) }
  else document.removeEventListener('click', onCdrTeamDocClick)
})

/* ── Etiquetas ───────────────────────────── */
const allLabels      = ref<LabelItem[]>([])
const labelsOpen     = ref(false)
const updatingLabels = ref(false)
const convLabels     = reactive<Record<number, string[]>>({})

/* Tooltip via JS (evita clipping do overflow-y: auto) */
const tt = ref<{ conv: Conversation; y: number } | null>(null)

/* ── Contact detail cache ────────────────── */
const contactCache   = reactive<Record<number, ContactDetail>>({})
const contactLoading = ref(0)

const contactDetail = computed<ContactDetail | null>(() => {
  const id = tt.value?.conv?.contact?.id
  return id ? (contactCache[id] ?? null) : null
})

const ttSocials = computed(() => {
  const sp = contactDetail.value?.additional_attributes?.social_profiles
  if (!sp) return []
  const MAP: Record<string, { label: string; color: string }> = {
    instagram: { label: 'IG', color: '#e1306c' },
    twitter:   { label: 'TW', color: '#1da1f2' },
    facebook:  { label: 'FB', color: '#1877f2' },
    linkedin:  { label: 'LI', color: '#0a66c2' },
    telegram:  { label: 'TG', color: '#0088cc' },
    tiktok:    { label: 'TK', color: '#010101' },
    github:    { label: 'GH', color: '#333' },
  }
  return Object.entries(sp)
    .filter(([, url]) => !!url)
    .map(([key, url]) => ({ ...MAP[key], key, url: url as string }))
    .filter(s => s.label)
})

/* ── Audio player + gravação de áudio ────── */
const {
  audioState, toggleAudio, seekAudio, audioProgress, fmtTime, disposeAudioEls,
  recording, recordingTime, recordedBlob, recordedUrl, waveformBars,
  startRecording, stopRecording, cancelRecording, sendRecordedAudio, fmtRecordingTime,
} = useAudioRecorder({
  barCount: 28,
  exclusivePlayback: true,
  onSend: async (file) => { files.value = [file]; await sendMsg() },
})

/* ── Gravação de vídeo ───────────────────── */
const videoRecording     = ref(false)
const videoRecordingTime = ref(0)
const videoRecordedBlob  = ref<Blob | null>(null)
const videoRecordedUrl   = ref('')
const videoPreviewEl     = ref<HTMLVideoElement | null>(null)
let _vmr: MediaRecorder | null = null
let _vstream: MediaStream | null = null
let _vrecTimer: ReturnType<typeof setInterval> | null = null

async function startVideoRecording() {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true })
    _vstream = stream
    const chunks: Blob[] = []
    const mimeType = MediaRecorder.isTypeSupported('video/webm;codecs=vp9,opus')
      ? 'video/webm;codecs=vp9,opus'
      : MediaRecorder.isTypeSupported('video/webm') ? 'video/webm' : 'video/mp4'
    _vmr = new MediaRecorder(stream, { mimeType })
    _vmr.ondataavailable = e => { if (e.data.size > 0) chunks.push(e.data) }
    _vmr.onstop = () => {
      const blob = new Blob(chunks, { type: mimeType })
      videoRecordedBlob.value = blob
      if (videoRecordedUrl.value) URL.revokeObjectURL(videoRecordedUrl.value)
      videoRecordedUrl.value = URL.createObjectURL(blob)
      stream.getTracks().forEach(t => t.stop())
    }
    _vmr.start(100)
    videoRecording.value = true
    videoRecordingTime.value = 0
    _vrecTimer = setInterval(() => videoRecordingTime.value++, 1000)
    await nextTick()
    if (videoPreviewEl.value) videoPreviewEl.value.srcObject = stream
  } catch {
    Swal.fire({ title: 'Câmera inacessível', text: 'Não foi possível acessar a câmera. Verifique as permissões do navegador.', icon: 'error' })
  }
}

function stopVideoRecording() {
  _vmr?.stop()
  videoRecording.value = false
  if (_vrecTimer) { clearInterval(_vrecTimer); _vrecTimer = null }
}

function cancelVideoRecording() {
  if (videoRecording.value) {
    if (_vmr) { _vmr.onstop = null; _vmr.stop() }
    _vstream?.getTracks().forEach(t => t.stop())
    videoRecording.value = false
    if (_vrecTimer) { clearInterval(_vrecTimer); _vrecTimer = null }
  }
  videoRecordedBlob.value = null
  if (videoRecordedUrl.value) { URL.revokeObjectURL(videoRecordedUrl.value); videoRecordedUrl.value = '' }
}

async function sendRecordedVideo() {
  if (!videoRecordedBlob.value) return
  const ext = videoRecordedBlob.value.type.includes('mp4') ? 'mp4' : 'webm'
  const file = new File([videoRecordedBlob.value], `video_${Date.now()}.${ext}`, { type: videoRecordedBlob.value.type })
  videoRecordedBlob.value = null
  if (videoRecordedUrl.value) { URL.revokeObjectURL(videoRecordedUrl.value); videoRecordedUrl.value = '' }
  files.value = [file]
  await sendMsg()
}

const panelWidth = ref(Math.max(MIN_W, Math.min(MAX_W, parseInt(localStorage.getItem('cdr_panel_w') || '320'))))

const API = `${CHATWOOT_BASE}/api/v1/accounts/3`

const {
  tplOpen: cdrTplOpen, tplsLoading: cdrTplsLoading, tplsApproved: cdrTplsApproved,
  tplSel: cdrTplSel, tplVarNums: cdrTplVarNums, tplVars: cdrTplVars, tplVarMapping: cdrTplVarMapping, tplImgUrl: cdrTplImgUrl,
  tplImgErr: cdrTplImgErr, tplSending: cdrTplSending, tplTime: cdrTplTime,
  tplHasImg: cdrTplHasImg, tplHeaderTxt: cdrTplHeaderTxt, tplFooterTxt: cdrTplFooterTxt,
  tplButtons: cdrTplButtons, tplPreviewHtml: cdrTplPreviewHtml,
  tplSendBlocked: cdrTplSendBlocked, tplSendBlockedReason: cdrTplSendBlockedReason,
  openTplModal: openCdrTplModal, closeTplModal: closeCdrTplModal,
  selectTpl: selectCdrTpl, setTplVar: setCdrTplVar, sendTpl: sendCdrTpl, mappedLabel: cdrMappedLabel,
} = useWhatsappTemplates({
  getContactPhone: () => activeConv.value?.contact?.phone,
  isWindowClosed:  () => cdrWindowClosed.value,
  getContact:      () => activeConv.value?.contact,
})

function apiHeaders(): Record<string, string> {
  return authHeaders(authUser.value?.access_token || '')
}

function apiUrl(path: string): string {
  return `${API}${path}?api_access_token=${authUser.value?.access_token || ''}`
}

/* ── Macros ──────────────────────────────── */
const cdrMacroPanelOpen   = ref(false)
const cdrMacrosList       = ref<CdrMacroItem[]>([])
const cdrMacrosLoading    = ref(false)
const cdrMacroSearch      = ref('')
const cdrMacroRunning     = ref(false)
const cdrMacroRunDone     = ref(false)
const cdrMacroRunningObj  = ref<CdrMacroItem | null>(null)
const cdrMacroStepResults = ref<{ label: string; ok: boolean; msg: string }[]>([])
const cdrMacroFormTarget  = ref<CdrMacroItem | null>(null)
const cdrMacroFormValues  = ref<Record<number, Record<string, string>>>({})

const cdrMacroFormActions = computed(() => {
  if (!cdrMacroFormTarget.value) return []
  return cdrMacroFormTarget.value.actions
    .map((action, idx) => ({ action, idx }))
    .filter(({ action }) => action.action_name === 'send_webhook_event_form')
    .map(({ action, idx }) => {
      const cfg = action.action_params?.[0] ?? {}
      const fields: Array<{ key: string; label: string }> = Array.isArray(cfg.fields) ? cfg.fields : []
      const url = typeof cfg === 'object' ? String(cfg.url ?? '') : ''
      return { idx, fields, url }
    })
    .filter(({ fields }) => fields.length > 0)
})

const cdrFilteredMacros = computed(() => {
  const q          = cdrMacroSearch.value.trim().toLowerCase()
  const convTeamId = activeConv.value?.team?.id ?? null
  const active     = cdrMacrosList.value.filter(m => {
    if (!m.is_active) return false
    if (!m.team_ids?.length) return true
    return convTeamId ? m.team_ids.includes(convTeamId) : true
  })
  return q ? active.filter(m => m.name.toLowerCase().includes(q)) : active
})

async function loadCdrMacros() {
  if (cdrMacrosList.value.length) return
  cdrMacrosLoading.value = true
  try {
    cdrMacrosList.value = await listMacros(authUser.value?.access_token || '')
  } catch { /* silencioso */ } finally {
    cdrMacrosLoading.value = false
  }
}

function toggleCdrMacroPanel() {
  cdrMacroPanelOpen.value = !cdrMacroPanelOpen.value
  if (cdrMacroPanelOpen.value) {
    loadCdrMacros()
    resetCdrMacroRun()
  }
}

function resetCdrMacroRun() {
  cdrMacroRunning.value     = false
  cdrMacroRunDone.value     = false
  cdrMacroRunningObj.value  = null
  cdrMacroStepResults.value = []
  cdrMacroFormTarget.value  = null
  cdrMacroFormValues.value  = {}
}

/**
 * Contexto pro motor de macro. Sempre parte dos dados já carregados no drawer;
 * se a macro tiver alguma ação de webhook, faz um GET da conversa pra ter
 * inbox_id/contact_email atualizados e a conversa bruta (fallback de corpo vazio).
 */
async function cdrMacroContext(macro: CdrMacroItem): Promise<MacroActionContext> {
  const conv = activeConv.value
  const base: MacroActionContext = {
    contactPhone:       conv?.contact?.phone ?? null,
    contactName:        conv?.contact?.name  ?? null,
    contactEmail:       (conv?.contact as any)?.email ?? null,
    teamId:             conv?.team?.id   ?? null,
    teamName:           conv?.team?.name ?? null,
    conversationStatus: conv?.status ?? null,
    contactId:          conv?.contact?.id ?? null,
    assigneeId:         conv?.assignee?.id ?? null,
    assigneeName:       conv?.assignee?.name ?? null,
    labels:             conv?.labels ?? [],
    accountId:          authUser.value?.account_id ?? null,
    macroId:            macro.id,
    macroName:          macro.name,
    executedById:       authUser.value?.id ?? null,
    executedByName:     authUser.value?.name ?? null,
  }
  const needsLiveContext = macro.actions.some(a => a.action_name === 'send_webhook_event' || a.action_name === 'send_webhook_event_form')
  if (!needsLiveContext || !conv) return base
  try {
    const data = await fetchConversation(conv.id, authUser.value?.access_token || '')
    if (!data) return base
    return {
      ...base,
      contactEmail: data?.meta?.sender?.email ?? base.contactEmail,
      inboxId:      data?.inbox_id ?? null,
      inboxName:    data?.channel ?? null,
      rawConversation: data,
    }
  } catch {
    return base
  }
}

async function runCdrMacro(macro: CdrMacroItem) {
  if (!activeConv.value) return

  const formActions = macro.actions
    .map((a, idx) => ({ action: a, idx }))
    .filter(({ action }) => action.action_name === 'send_webhook_event_form')
    .filter(({ action }) => {
      const cfg = action.action_params?.[0] ?? {}
      return Array.isArray(cfg.fields) && cfg.fields.length > 0
    })

  if (formActions.length) {
    const vals: Record<number, Record<string, string>> = {}
    for (const { action, idx } of formActions) {
      const cfg = action.action_params?.[0] ?? {}
      const fields: Array<{ key: string; label: string }> = Array.isArray(cfg.fields) ? cfg.fields : []
      vals[idx] = {}
      for (const field of fields) vals[idx][field.key] = ''
    }
    cdrMacroFormValues.value = vals
    cdrMacroFormTarget.value = macro
    return
  }

  await executeCdrMacro(macro, {})
}

async function submitCdrMacroForm() {
  if (!cdrMacroFormTarget.value) return
  const macro = cdrMacroFormTarget.value
  const formValuesByIdx = { ...cdrMacroFormValues.value }
  cdrMacroFormTarget.value = null
  await executeCdrMacro(macro, formValuesByIdx)
}

async function executeCdrMacro(macro: CdrMacroItem, formValuesByIdx: Record<number, Record<string, string>>) {
  if (!activeConv.value) return
  const convId = activeConv.value.id
  cdrMacroRunningObj.value  = macro
  cdrMacroRunning.value     = true
  cdrMacroRunDone.value     = false
  cdrMacroStepResults.value = []
  const context = await cdrMacroContext(macro)
  for (const [idx, action] of macro.actions.entries()) {
    const formVals = action.action_name === 'send_webhook_event_form'
      ? (formValuesByIdx[idx] ?? {})
      : undefined
    cdrMacroStepResults.value.push(
      await runMacroAction(action, convId, authUser.value?.access_token || '', context, formVals)
    )
  }
  cdrMacroRunning.value = false
  cdrMacroRunDone.value = true
}

/* ── Computed ────────────────────────────── */
const { myConvs } = useMyConversations()

const panelVisible = computed(() => (listOpen.value || chatOpen.value) && railMode.value === 'client' && !hiddenOnFoco.value)

watch(myConvs, () => nextTick(updateStripScrollState), { flush: 'post' })

// Busca/filtro por nome ou telefone do contato na lista "Minhas Conversas" —
// não mexe na ordem de myConvs, só filtra o que é exibido.
const convSearch = ref('')
const filteredMyConvs = computed(() => {
  const q = convSearch.value.trim().toLowerCase()
  if (!q) return myConvs.value
  return myConvs.value.filter(c =>
    c.contact.name.toLowerCase().includes(q) || c.contact.phone.toLowerCase().includes(q)
  )
})
watch(panelVisible, open => { if (!open) convSearch.value = '' })

const activeConv = computed(() =>
  selConvId.value != null ? myConvs.value.find(c => c.id === selConvId.value) ?? null : null
)

watch([activeConv, chatOpen], ([conv, open]) => {
  activeConvContext.value = open && conv ? { id: conv.id, fluxoId: conv.fluxo_id, cnpj: conv.cnpj } : null
})

const { getProfileForFluxo: getSLAProfile } = useSLA()

const activeConvDocument = computed(() => activeConv.value ? conversationDocument(activeConv.value) : null)

const activeSLABadge = computed<SLABadge | null>(() => {
  const conv = activeConv.value
  if (!conv || (conv.status !== 'open' && conv.status !== 'pending')) return null
  const profile = getSLAProfile(conv.fluxo_id)
  if (!profile) return null
  const now = cdrNowSec.value
  const candidates: { remaining: number; label: string; status: 'breached' | 'atRisk' }[] = []

  if (profile.resolutionTime > 0) {
    const deadline = conv.created_at + profile.resolutionTime * 60
    const remaining = deadline - now
    if (remaining <= 0) candidates.push({ remaining, label: 'Resolução', status: 'breached' })
    else if (profile.notifyBefore > 0 && remaining <= profile.notifyBefore * 60)
      candidates.push({ remaining, label: 'Resolução', status: 'atRisk' })
  }
  if (profile.firstResponseTime > 0 && conv.waiting_since > 0) {
    const deadline = conv.waiting_since + profile.firstResponseTime * 60
    const remaining = deadline - now
    if (remaining <= 0) candidates.push({ remaining, label: '1ª Resposta', status: 'breached' })
    else if (profile.notifyBefore > 0 && remaining <= profile.notifyBefore * 60)
      candidates.push({ remaining, label: '1ª Resposta', status: 'atRisk' })
  }
  if (!candidates.length) return null
  candidates.sort((a, b) => a.remaining - b.remaining)
  const worst = candidates[0]
  const abs = Math.abs(Math.floor(worst.remaining))
  const h = Math.floor(abs / 3600), m = Math.floor((abs % 3600) / 60), s = abs % 60
  const timeStr = worst.remaining <= 0
    ? `+${h > 0 ? h + 'h ' : ''}${m > 0 ? m + 'min' : s + 's'}`
    : `${h > 0 ? h + 'h ' : ''}${m > 0 ? m + 'min' : s + 's'}`
  return { label: worst.label, time: timeStr, status: worst.status }
})

const cdrSnoozeRemainingLabel = computed<string | null>(() => {
  const conv = activeConv.value
  if (!conv || conv.status !== 'snoozed' || !conv.snoozed_until) return null
  const diff = conv.snoozed_until - cdrNowSec.value
  if (diff <= 0) return null
  const h = Math.floor(diff / 3600)
  const m = Math.floor((diff % 3600) / 60)
  if (h > 0) return `${h}h ${m > 0 ? m + 'min' : ''}`
  if (m > 0) return `${m}min`
  return 'menos de 1min'
})

const processedMsgs = computed<ProcessedMsg[]>(() => {
  if (!selConvId.value) return []
  const msgs = (msgCache.value[selConvId.value] || [])
    .filter(m => m.message_type <= 2 && (m.content || m.attachments?.length))
  return msgs.map((msg, i) => {
    const next = msgs[i + 1]
    // mostra avatar na última mensagem de cada grupo de remetente consecutivo
    const showAvatar = !next || next.message_type !== msg.message_type
    return { ...msg, showAvatar }
  })
})

const canSend = computed(() => draft.value.trim().length > 0 || files.value.length > 0)

const { isWindowClosed: cdrWindowClosed } = useMessageWindow(processedMsgs, cdrNowSec)

// Notas internas exigem a janela aberta (mesmo composer da mensagem normal) — se a janela
// fechar enquanto o toggle está ativo, desativa pra não deixar o composer num estado inválido.
watch(cdrWindowClosed, (closed) => { if (closed) notaInterna.value = false })

/* ── Message search ── */
const {
  msgSearchOpen, msgSearchQuery, msgSearchActive, msgSearchLoading, msgCurrentIdx, msgSearchInputEl,
  msgMatchIds, getSig, highlightMsgHtml,
  openMsgSearch, closeMsgSearch, doMsgSearch, goNextMsg, goPrevMsg,
} = useMessageSearch({
  processedMsgs,
  msgsEl,
  messageSignature: () => authUser.value?.message_signature || '',
  loadMoreMsgs,
  noMoreMsgs,
})

const currentLabels = computed<string[]>(() => {
  if (!selConvId.value) return []
  return convLabels[selConvId.value] ?? activeConv.value?.labels ?? []
})

/* ── Tooltip ─────────────────────────────── */
function showTT(conv: Conversation, e: MouseEvent) {
  const rect = (e.currentTarget as HTMLElement).getBoundingClientRect()
  tt.value = { conv, y: Math.round(rect.top + rect.height / 2) }
  if (conv.contact.id && !contactCache[conv.contact.id]) fetchContactDetail(conv.contact.id)
}
function hideTT() { tt.value = null }

async function fetchContactDetail(id: number) {
  if (contactCache[id] || contactLoading.value === id) return
  contactLoading.value = id
  try {
    const res = await fetch(apiUrl(`/contacts/${id}`), { headers: apiHeaders() })
    if (!res.ok) return
    const data = await res.json()
    contactCache[id] = data.payload
  } catch { /* silencioso */ } finally {
    if (contactLoading.value === id) contactLoading.value = 0
  }
}

/* ── Panel control ───────────────────────── */
function toggleList() {
  if (chatOpen.value) { chatOpen.value = false; listOpen.value = true; return }
  listOpen.value = !listOpen.value
  if (listOpen.value) prefetchPreviews()
}

function closePanel() {
  listOpen.value = false
  chatOpen.value = false
  selConvId.value = null
  currentOpenConvId.value = null
}

function backToList() {
  chatOpen.value = false
  listOpen.value = true
}

const cdrExporting = ref(false)

async function exportActiveConv() {
  const conv = activeConv.value
  if (!conv || cdrExporting.value) return
  cdrExporting.value = true
  try {
    const messages = await fetchConversationMessagesForExportApi(authUser.value?.access_token || '', conv.id)
    const convForExport = {
      id:               conv.id,
      status:           conv.status,
      created_at:       conv.created_at,
      last_activity_at: conv.resolved_at,
      meta: {
        sender:   conv.contact,
        assignee: conv.assignee,
        team:     conv.team,
        channel:  conv.channel,
      },
    }
    const html = buildConvHtml(convForExport, messages, conv.contact.name)
    downloadHtmlFile(html, `conversa-${conv.id}-${new Date().toISOString().slice(0, 10)}.html`)
  } catch (e: any) {
    Swal.fire({ title: 'Erro ao exportar', text: e.message || 'Não foi possível buscar as mensagens.', icon: 'error' })
  } finally {
    cdrExporting.value = false
  }
}

function selectConv(conv: Conversation) {
  hideTT()
  if (selConvId.value === conv.id && chatOpen.value) { closePanel(); return }
  openChat(conv)
}

async function openChat(conv: Conversation) {
  localReadConvIds.add(conv.id)   // limpa badge imediatamente
  selConvId.value = conv.id
  listOpen.value  = false
  chatOpen.value  = true
  convLabels[conv.id] = [...conv.labels]
  labelsOpen.value = false
  fetchAllLabels()
  // Reabrir uma conversa já vista nesta sessão usa fetchMsgs em modo silencioso
  // (sem "loadingMsgs = true", sem spinner de tela cheia cobrindo o que já tem
  // em msgCache) — processedMsgs já é reativo a selConvId+msgCache, então o
  // histórico cacheado aparece na hora, e o fetch só faz merge por cima. Só a
  // primeira abertura de uma conversa (sem cache ainda) usa silent=false.
  // fetchMsgs decide se rola pro fim sozinho só quando NÃO é silencioso — pra
  // não depender do scroll da conversa anterior ainda na tela nesse instante,
  // força o scroll pro fim aqui depois, cobrindo os dois casos.
  const hadCache = !!msgCache.value[conv.id]
  await fetchMsgs(conv.id, hadCache)
  if (selConvId.value === conv.id) { await nextTick(); scrollBottom() }
}

async function openById(id: number) {
  let conv = conversations.value.find(c => c.id === id)
  if (!conv) {
    // Conversa fora do escopo já carregado localmente (ex.: resultado da busca global
    // apontando pra uma conversa resolvida há tempo, ou de um time não listado agora) —
    // busca avulsa igual ao fluxo de "conversa nova via WebSocket" em useDashboardEngine.ts.
    const fetched = await fetchConversationById(id, authUser.value?.access_token || '')
    if (!fetched) {
      Swal.fire({ title: 'Conversa não encontrada', text: `Não foi possível abrir a conversa #${id}.`, icon: 'error' })
      return
    }
    conversations.value = [...conversations.value, fetched]
    conv = fetched
  }
  await openChat(conv)
}

watch(pendingChatId, async (id) => {
  if (id === null) return
  pendingChatId.value = null
  // Força o trilho pro modo "cliente" — sem isso o popup fica montado mas invisível
  // quando o agente estava no modo "agente" (AgentChatDrawer) ou o strip inteiro
  // escondido (cdr-strip só renderiza com railMode === 'client', ver topo do template).
  railMode.value = 'client'
  currentOpenConvId.value = id
  await openById(id)
})

watch(closeDrawerSignal, (val) => {
  if (val > 0 && (chatOpen.value || listOpen.value)) closePanel()
})

watch(focusReplySignal, (val) => {
  if (val > 0 && chatOpen.value) nextTick(() => taEl.value?.focus())
})

// Atalho "C" — mesmo efeito de clicar no ícone "Minhas Conversas" do rail; se o rail
// estiver no modo "agente", troca pra "cliente" e já abre a lista em vez de só alternar.
watch(openMyConvsSignal, (val) => {
  if (val === 0) return
  if (railMode.value !== 'client') {
    railMode.value = 'client'
    listOpen.value = true
    prefetchPreviews()
  } else {
    toggleList()
  }
})

/* ── Labels API ──────────────────────────── */
async function fetchAllLabels() {
  if (allLabels.value.length) return
  try {
    allLabels.value = await fetchAccountLabels(authUser.value?.access_token || '')
  } catch { /* silencioso */ }
}

async function toggleLabel(label: string) {
  if (!selConvId.value || updatingLabels.value) return
  const convId = selConvId.value
  const current = [...(convLabels[convId] ?? activeConv.value?.labels ?? [])]
  const next = current.includes(label) ? current.filter(l => l !== label) : [...current, label]
  updatingLabels.value = true
  try {
    const result = await setConversationLabels(convId, authUser.value?.access_token || '', next)
    if (result) convLabels[convId] = result
  } catch (e) {
    console.error('[ConvDrawer] labels:', e)
  } finally {
    updatingLabels.value = false
  }
}

function onLblDocClick(e: MouseEvent) {
  const el = document.querySelector('.cdr-lbl-picker')
  if (el && !el.contains(e.target as Node)) labelsOpen.value = false
}

watch(labelsOpen, open => {
  if (open) setTimeout(() => document.addEventListener('click', onLblDocClick), 0)
  else document.removeEventListener('click', onLblDocClick)
})

/* ── Fetch messages ──────────────────────── */
// Merge por id (não substitui o array inteiro): uma atualização silenciosa
// (poll de 8s/evento realtime) só traz o lote recente da API — sobrescrever
// o cache com isso descartava o histórico já carregado via loadMoreMsgs e
// resetava a posição de quem tava lendo mensagens antigas. Ordena de novo
// por segurança (created_at), já que o merge não garante ordem.
function mergeMsgs(existing: ChatMessage[], incoming: ChatMessage[]): ChatMessage[] {
  const byId = new Map(existing.map(m => [m.id, m]))
  incoming.forEach(m => byId.set(m.id, m))
  return [...byId.values()].sort((a, b) => a.created_at - b.created_at)
}

// "Perto do fim" = auto-scroll é esperado (chat normal); acima disso, quem
// tá lendo histórico não pode ser puxado pro fim por uma atualização em segundo plano.
function isNearBottom(): boolean {
  const el = msgsEl.value
  if (!el) return true
  return el.scrollHeight - el.scrollTop - el.clientHeight < 120
}

async function fetchMsgs(convId: number, silent = true) {
  if (!silent) loadingMsgs.value = true
  noMoreMsgs.value = false
  const wasNearBottom = isNearBottom()
  try {
    const messages = await fetchMessages(convId)
    if (messages !== null) {
      // Toca o som só quando já havia cache pra essa conversa (evita disparar
      // pra cada mensagem do histórico na primeira abertura) e a mensagem nova
      // é do contato (message_type 0 = incoming, 1 = outgoing, 2 = atividade).
      const prevMsgs = msgCache.value[convId]
      if (prevMsgs) {
        const prevIds = new Set(prevMsgs.map(m => m.id))
        if (messages.some(m => m.message_type === 0 && !prevIds.has(m.id))) playNotificationSound()
      }
      msgCache.value = {
        ...msgCache.value,
        [convId]: silent && prevMsgs ? mergeMsgs(prevMsgs, messages) : messages,
      }
    }
  } catch (e) {
    console.error('[ConvDrawer]', e)
  } finally {
    loadingMsgs.value = false
    if (convId === selConvId.value && (!silent || wasNearBottom)) {
      await nextTick()
      scrollBottom()
    }
  }
}

// Evento realtime (message.created/updated da conversa aberta) — usa a
// mensagem que já vem no próprio evento (ver useChatwootMessageRealtime.ts)
// e faz merge direto no cache, sem golpe de rede. O poll de 8s continua
// existindo como rede de segurança (via fetchMsgs acima, já não-destrutivo).
function onRealtimeMsg(convId: number, message: ChatMessage) {
  const prevMsgs = msgCache.value[convId]
  if (!prevMsgs) { fetchMsgs(convId, true); return } // sem cache ainda (raro) — cai pro fetch normal
  const isNewIncoming = message.message_type === 0 && !prevMsgs.some(m => m.id === message.id)
  const wasNearBottom = isNearBottom()
  msgCache.value = { ...msgCache.value, [convId]: mergeMsgs(prevMsgs, [message]) }
  if (isNewIncoming) playNotificationSound()
  if (convId === selConvId.value && wasNearBottom) nextTick(() => scrollBottom())
}

async function loadMoreMsgs() {
  const convId = selConvId.value
  if (!convId || loadingMore.value || noMoreMsgs.value) return
  const current = msgCache.value[convId] ?? []
  if (!current.length) return
  loadingMore.value = true
  const prevHeight = msgsEl.value?.scrollHeight ?? 0
  try {
    const result = await fetchOlderMessages(convId, current)
    if (result.noMore) { noMoreMsgs.value = true; return }
    if (result.messages === current) return
    msgCache.value = { ...msgCache.value, [convId]: result.messages }
    await nextTick()
    if (msgsEl.value) msgsEl.value.scrollTop = msgsEl.value.scrollHeight - prevHeight
  } catch (e) {
    console.error('[ConvDrawer loadMore]', e)
  } finally {
    loadingMore.value = false
  }
}

function onMsgsScroll() {
  if (msgsEl.value && msgsEl.value.scrollTop < 60) loadMoreMsgs()
}

async function prefetchPreviews() {
  for (const conv of myConvs.value) {
    if (!msgCache.value[conv.id]) await fetchMsgs(conv.id, true)
  }
}

/* ── Send ────────────────────────────────── */
const { sending, sendMsg } = useMessageSender({
  getConvId: () => selConvId.value,
  getToken: () => authUser.value?.access_token || '',
  getContactPhone: () => activeConv.value?.contact?.phone,
  getSig,
  draft,
  files,
  isPrivate: notaInterna,
  fileInputEl,
  taEl,
  scrollBottom,
  getAssigneeId: () => currentAssignee.value?.id ?? null,
  getMyAgentId: () => authUser.value?.id ?? 0,
  getLabels: () => currentLabels.value,
  getStatus: () => activeConv.value?.status,
  onMessageCreated: (msg, convId) => {
    if (!msgCache.value[convId]) msgCache.value[convId] = []
    msgCache.value[convId] = [...msgCache.value[convId], msg]
  },
  onSent: (convId) => localReadConvIds.add(convId),  // agente enviou → limpa badge
  onLabelsChanged: (convId, labels) => { convLabels[convId] = labels },
  onStatusChanged: (convId, status) => {
    const idx = conversations.value.findIndex(c => c.id === convId)
    if (idx !== -1) conversations.value[idx] = { ...conversations.value[idx], status }
  },
  onAutoAssigned: (convId, agentId) => {
    const me = authUser.value
    if (!me) return
    convAssignee[convId] = { id: agentId, name: me.name, thumbnail: me.avatar_url }
    const idx = conversations.value.findIndex(c => c.id === convId)
    if (idx !== -1) conversations.value[idx] = {
      ...conversations.value[idx],
      assignee: { id: agentId, name: me.name, email: me.email, role: 'agent', thumbnail: me.avatar_url, availability: 'online' },
    }
  },
})

function onFilePick(e: Event) {
  const input = e.target as HTMLInputElement
  if (input.files) { files.value.push(...Array.from(input.files)); input.value = '' }
}

function growTa() {
  const el = taEl.value
  if (!el) return
  el.style.height = 'auto'
  el.style.height = Math.min(el.scrollHeight, 120) + 'px'
}

function insertEmoji(em: string) {
  const el = taEl.value
  if (!el) { draft.value += em; return }
  const start = el.selectionStart ?? draft.value.length
  const end   = el.selectionEnd   ?? draft.value.length
  draft.value = draft.value.slice(0, start) + em + draft.value.slice(end)
  nextTick(() => {
    el.selectionStart = el.selectionEnd = start + em.length
    el.focus()
    growTa()
  })
}

function scrollBottom() {
  if (msgsEl.value) msgsEl.value.scrollTop = msgsEl.value.scrollHeight
}

/* ── Resize ──────────────────────────────── */
let _rx = false, _sx = 0, _sw = 0

function startResize(e: MouseEvent) {
  _rx = true; _sx = e.clientX; _sw = panelWidth.value
  document.addEventListener('mousemove', doResize)
  document.addEventListener('mouseup', stopResize)
  document.body.style.userSelect = 'none'
  document.body.style.cursor = 'col-resize'
}
function doResize(e: MouseEvent) {
  if (!_rx) return
  panelWidth.value = Math.max(MIN_W, Math.min(MAX_W, _sw + (_sx - e.clientX)))
}
function stopResize() {
  _rx = false
  document.removeEventListener('mousemove', doResize)
  document.removeEventListener('mouseup', stopResize)
  document.body.style.userSelect = ''
  document.body.style.cursor = ''
  localStorage.setItem('cdr_panel_w', String(panelWidth.value))
}

/* ── Polling ─────────────────────────────── */
let pollTimer: ReturnType<typeof setInterval> | null = null

watch(chatOpen, open => {
  if (open && selConvId.value) {
    pollTimer = setInterval(() => { if (selConvId.value) fetchMsgs(selConvId.value, true) }, 8000)
  } else {
    if (pollTimer) { clearInterval(pollTimer); pollTimer = null }
  }
})

// Mensagens em tempo real (Fase 5 do plano — docs/planos/PLANO-REALTIME-ACTIONCABLE.md):
// aplica a mensagem do próprio evento direto no cache (onRealtimeMsg, sem
// refetch) na hora que chega message.created/updated pra conversa aberta, em
// vez de esperar o próximo tick do poll de 8s acima — que continua existindo
// do mesmo jeito, como rede de segurança (cobre a limitação de inbox/admin
// da Fase 3, e qualquer evento perdido).
let msgRealtimeUnsub: (() => void) | null = null

watch([chatOpen, selConvId], ([open, convId]) => {
  msgRealtimeUnsub?.()
  msgRealtimeUnsub = null
  if (open && convId) {
    msgRealtimeUnsub = onConversationMessage(convId, message => onRealtimeMsg(convId, message))
  }
})

let _nowTimer: ReturnType<typeof setInterval> | null = null

onMounted(() => {
  conversations.value.forEach(c => { prevUnreadMap[c.id] = c.unread_count })
  _nowTimer = setInterval(() => { cdrNowSec.value = Math.floor(Date.now() / 1000) }, 30_000)
})

onUnmounted(() => {
  document.removeEventListener('mousemove', doResize)
  document.removeEventListener('mouseup', stopResize)
  if (pollTimer) clearInterval(pollTimer)
  if (_nowTimer) clearInterval(_nowTimer)
  msgRealtimeUnsub?.()
  disposeAudioEls()
  cancelRecording()
  cancelVideoRecording()
  document.removeEventListener('click', onLblDocClick)
  document.removeEventListener('click', onCdrStatusDocClick)
  document.removeEventListener('click', onCdrTeamDocClick)
})

/* ── Helpers ─────────────────────────────── */
function previewText(convId: number): string {
  const msgs = msgCache.value[convId]
  if (!msgs?.length) return 'Abrir conversa…'
  const last = msgs[msgs.length - 1]
  if (last?.content) return last.content.slice(0, 60)
  if (last?.attachments?.length) {
    const t = last.attachments[0].file_type
    return t === 'image' ? '📷 Imagem' : t === 'audio' ? '🎵 Áudio' : t === 'video' ? '🎥 Vídeo' : '📎 Arquivo'
  }
  return '—'
}

function convTime(conv: Conversation): string {
  const ts = conv.created_at; if (!ts) return ''
  const d = new Date(ts * 1000), now = new Date()
  return d.toDateString() === now.toDateString()
    ? d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
}

function fmtTs(ts: number): string {
  const d = new Date(ts * 1000)
  return `${d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })} ${d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`
}

function statusDot(conv: Conversation): string {
  if (conv.unread_count > 0 && !localReadConvIds.has(conv.id)) return 'dot-new'
  if (conv.status === 'pending') return 'dot-pending'
  if (conv.status === 'snoozed') return 'dot-snoozed'
  return 'dot-open'
}

function statusLabel(conv: Conversation): string {
  if (conv.unread_count > 0 && !localReadConvIds.has(conv.id)) return 'Nova mensagem'
  if (conv.status === 'pending') return 'Pendente'
  if (conv.status === 'snoozed') return 'Adiado'
  return 'Em aberto'
}

function convStatusLabel(s: string): string {
  return ({ open: 'Aberto', resolved: 'Resolvido', pending: 'Pendente', snoozed: 'Adiado' } as Record<string,string>)[s] ?? 'Aberto'
}

// Copiar telefone do contato (cabeçalho do chat) — feedback visual breve, mesmo
// padrão do copyJson em TemplatesView.vue (ref booleana + timeout de 2s).
const phoneCopied = ref(false)
async function copyPhone(phone: string) {
  if (!phone) return
  await navigator.clipboard.writeText(phone)
  phoneCopied.value = true
  setTimeout(() => { phoneCopied.value = false }, 2000)
}

function onCdrStatusDocClick() {
  cdrStatusMenuOpen.value = false
  cdrSnoozeMode.value = false
}
watch(cdrStatusMenuOpen, open => {
  if (open) setTimeout(() => document.addEventListener('click', onCdrStatusDocClick), 0)
  else document.removeEventListener('click', onCdrStatusDocClick)
})

async function cdrChangeStatus(status: string, snoozedUntil: number | null = null) {
  if (cdrStatusLoading.value || !activeConv.value) return
  if (status === 'resolved') {
    cdrStatusMenuOpen.value = false
    if (!(await confirmResolveConversation())) return
  }
  cdrStatusLoading.value = true
  cdrStatusMenuOpen.value = false
  cdrSnoozeMode.value = false
  const convId = activeConv.value.id
  try {
    let newStatus: string | null
    if (status === 'snoozed') {
      const result = await snoozeConversation(convId, authUser.value?.access_token || '', snoozedUntil)
      newStatus = result.status
    } else if (status === 'resolved') {
      const conv = activeConv.value
      const context: MacroActionContext = {
        contactPhone:       conv?.contact?.phone ?? null,
        contactName:        conv?.contact?.name  ?? null,
        contactEmail:       (conv?.contact as any)?.email ?? null,
        teamId:             conv?.team?.id   ?? null,
        teamName:           conv?.team?.name ?? null,
        conversationStatus: conv?.status ?? null,
        contactId:          conv?.contact?.id ?? null,
        assigneeId:         conv?.assignee?.id ?? null,
        assigneeName:       conv?.assignee?.name ?? null,
        labels:             conv?.labels ?? [],
        accountId:          authUser.value?.account_id ?? null,
        executedById:       authUser.value?.id ?? null,
        executedByName:     authUser.value?.name ?? null,
      }
      const outcome = await resolveConversationSmart(convId, authUser.value?.access_token || '', context)
      if (!outcome.ok) return
      newStatus = outcome.status ?? 'resolved'
    } else {
      newStatus = await toggleConversationStatus(convId, authUser.value?.access_token || '', status)
      if (newStatus === null) return
    }
    const idx = conversations.value.findIndex(c => c.id === convId)
    if (idx !== -1) conversations.value[idx] = { ...conversations.value[idx], status: newStatus, snoozed_until: snoozedUntil }
    // myConvs exclui resolvidas — sem isso activeConv fica null com chatOpen
    // ainda true, e nem a lista nem o chat renderizam (painel em branco).
    if (newStatus === 'resolved') backToList()
  } catch { /* silencioso */ } finally {
    cdrStatusLoading.value = false
  }
}

function cdrConfirmSnooze() {
  const total = (cdrSnoozeH.value || 0) * 3600 + (cdrSnoozeM.value || 0) * 60
  const until = total > 0 ? Math.floor(Date.now() / 1000) + total : null
  cdrChangeStatus('snoozed', until)
}

function senderName(msg: ChatMessage): string {
  return msg.sender?.name || msg.sender?.available_name || '?'
}

function chatwootUrl(id: number): string {
  return `https://chatwoot.isbet.org.br/app/accounts/3/conversations/${id}`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(railMode) === 'client' && !hiddenOnFoco.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["cdr-strip", { 'is-expanded': panelVisible.value }])
        }, [
          _cache[84] || (_cache[84] = _createElementVNode("div", { class: "cdr-strip-cap" }, null, -1)),
          _createElementVNode("div", {
            class: "cdr-strip-head",
            onClick: toggleList,
            title: listOpen.value ? 'Fechar' : 'Minhas conversas'
          }, [
            _cache[68] || (_cache[68] = _createElementVNode("svg", {
              width: "17",
              height: "17",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
            ], -1)),
            (_unref(myConvs).length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(myConvs).length > 9 ? '9+' : _unref(myConvs).length), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_1),
          _createElementVNode("div", _hoisted_3, [
            (canScrollUp.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "cdr-scroll-btn up",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollStrip(-1))),
                  title: "Rolar para cima"
                }, [...(_cache[69] || (_cache[69] = [
                  _createElementVNode("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("polyline", { points: "18 15 12 9 6 15" })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "cdr-av-list",
              ref_key: "stripListEl",
              ref: stripListEl,
              onScroll: updateStripScrollState
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(myConvs), (conv) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: conv.id,
                  class: _normalizeClass(["cdr-av-item", { active: selConvId.value === conv.id }]),
                  onClick: ($event: any) => (selectConv(conv)),
                  onMouseenter: ($event: any) => (showTT(conv, $event)),
                  onMouseleave: hideTT
                }, [
                  _createElementVNode("div", {
                    class: "cdr-av",
                    style: _normalizeStyle({ background: _unref(avatarColor)(conv.contact.name) })
                  }, [
                    (conv.contact.thumbnail)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: conv.contact.thumbnail,
                          alt: conv.contact.name,
                          onError: _cache[1] || (_cache[1] = (e) => (e.target as HTMLImageElement).style.display='none')
                        }, null, 40, _hoisted_5))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(initials)(conv.contact.name)), 1))
                  ], 4),
                  _createElementVNode("span", {
                    class: _normalizeClass(["cdr-status-dot", statusDot(conv)])
                  }, null, 2),
                  (conv.unread_count > 0 && !localReadConvIds.has(conv.id))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(conv.unread_count > 9 ? '9+' : conv.unread_count), 1))
                    : (conv.status === 'snoozed')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, [...(_cache[70] || (_cache[70] = [
                          _createElementVNode("svg", {
                            width: "7",
                            height: "7",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "3",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("circle", {
                              cx: "12",
                              cy: "12",
                              r: "10"
                            }),
                            _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true)
                ], 42, _hoisted_4))
              }), 128)),
              (!_unref(myConvs).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[71] || (_cache[71] = [
                    _createElementVNode("svg", {
                      width: "18",
                      height: "18",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.8",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true)
            ], 544),
            (canScrollDown.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "cdr-scroll-btn down",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (scrollStrip(1))),
                  title: "Rolar para baixo"
                }, [...(_cache[72] || (_cache[72] = [
                  _createElementVNode("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          (_unref(can)('agentChat.view'))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "cdr-strip-footer",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(toggleRailMode) && _unref(toggleRailMode)(...args))),
                title: "Alternar para chat entre agentes"
              }, [
                _cache[73] || (_cache[73] = _createElementVNode("svg", {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                ], -1)),
                (_unref(agentChatUnread) > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(agentChatUnread) > 9 ? '9+' : _unref(agentChatUnread)), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            _createVNode(_Transition, { name: "tt-pill" }, {
              default: _withCtx(() => [
                (tt.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "cdr-tt-card",
                      style: _normalizeStyle({ top: tt.value.y + 'px', right: (STRIP_W + 8) + 'px' })
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", {
                          class: "cdr-ttc-av",
                          style: _normalizeStyle({ background: _unref(avatarColor)(tt.value.conv.contact.name) })
                        }, [
                          (tt.value.conv.contact.thumbnail)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: tt.value.conv.contact.thumbnail,
                                alt: tt.value.conv.contact.name,
                                onError: _cache[4] || (_cache[4] = (e) => (e.target as HTMLImageElement).style.display='none')
                              }, null, 40, _hoisted_12))
                            : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(initials)(tt.value.conv.contact.name)), 1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["cdr-ttc-av-dot", statusDot(tt.value.conv)])
                          }, null, 2)
                        ], 4),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("span", _hoisted_16, _toDisplayString(tt.value.conv.contact.name || tt.value.conv.contact.phone || '#' + tt.value.conv.id), 1),
                            (tt.value.conv.unread_count > 0 && !localReadConvIds.has(tt.value.conv.id))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(tt.value.conv.unread_count > 9 ? '9+' : tt.value.conv.unread_count), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_18, "#" + _toDisplayString(tt.value.conv.id), 1)
                        ])
                      ]),
                      _cache[77] || (_cache[77] = _createElementVNode("div", { class: "cdr-ttc-divider" }, null, -1)),
                      _createElementVNode("div", _hoisted_19, [
                        (tt.value.conv.contact.phone)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                              _cache[74] || (_cache[74] = _createElementVNode("svg", {
                                width: "11",
                                height: "11",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13 19.79 19.79 0 0 1 1.61 4.44 2 2 0 0 1 3.59 2.24h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.29 6.29l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" })
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(_unref(fmtPhone)(tt.value.conv.contact.phone)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (tt.value.conv.team)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                              _cache[75] || (_cache[75] = _createElementVNode("svg", {
                                width: "11",
                                height: "11",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                                _createElementVNode("circle", {
                                  cx: "9",
                                  cy: "7",
                                  r: "4"
                                }),
                                _createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }),
                                _createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(tt.value.conv.team.name), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (tt.value.conv.assignee)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                              _cache[76] || (_cache[76] = _createElementVNode("svg", {
                                width: "11",
                                height: "11",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                                _createElementVNode("circle", {
                                  cx: "12",
                                  cy: "7",
                                  r: "4"
                                })
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(tt.value.conv.assignee.name), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_23, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["cdr-ttc-dot", statusDot(tt.value.conv)])
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(statusLabel(tt.value.conv)), 1)
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])),
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            _createVNode(_Transition, { name: "tt-fade" }, {
              default: _withCtx(() => [
                false
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "cdr-tt",
                      style: _normalizeStyle({ top: tt.value?.y + 'px', right: (STRIP_W + 10) + 'px' })
                    }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", {
                          class: "cdr-tt-av",
                          style: _normalizeStyle({ background: _unref(avatarColor)(tt.value.conv.contact.name) })
                        }, [
                          (contactDetail.value?.thumbnail)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: contactDetail.value.thumbnail,
                                alt: tt.value.conv.contact.name,
                                onError: _cache[5] || (_cache[5] = (e) => (e.target as HTMLImageElement).style.display='none')
                              }, null, 40, _hoisted_25))
                            : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(initials)(tt.value.conv.contact.name)), 1))
                        ], 4),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, _toDisplayString(tt.value.conv.contact.name), 1),
                          (contactDetail.value?.additional_attributes?.company_name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(contactDetail.value.additional_attributes.company_name), 1))
                            : (contactLoading.value === tt.value.conv.contact.id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Carregando… "))
                              : _createCommentVNode("", true)
                        ])
                      ]),
                      _cache[83] || (_cache[83] = _createElementVNode("div", { class: "cdr-tt-divider" }, null, -1)),
                      (tt.value.conv.contact.phone)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _cache[78] || (_cache[78] = _createElementVNode("svg", {
                              width: "10",
                              height: "10",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13 19.79 19.79 0 0 1 1.61 4.44 2 2 0 0 1 3.59 2.24h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.29 6.29l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(tt.value.conv.contact.phone), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (contactDetail.value?.email)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _cache[79] || (_cache[79] = _createElementVNode("svg", {
                              width: "10",
                              height: "10",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" }),
                              _createElementVNode("polyline", { points: "22,6 12,13 2,6" })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(contactDetail.value.email), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (contactDetail.value?.additional_attributes?.city)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _cache[80] || (_cache[80] = _createElementVNode("svg", {
                              width: "10",
                              height: "10",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" }),
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "10",
                                r: "3"
                              })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(contactDetail.value.additional_attributes.city), 1),
                            (contactDetail.value.additional_attributes.country)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_34, ", " + _toDisplayString(contactDetail.value.additional_attributes.country), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (contactDetail.value?.additional_attributes?.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, " \"" + _toDisplayString(contactDetail.value.additional_attributes.description) + "\" ", 1))
                        : _createCommentVNode("", true),
                      (ttSocials.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ttSocials.value, (s) => {
                              return (_openBlock(), _createElementBlock("a", {
                                key: s.key,
                                href: s.url,
                                target: "_blank",
                                rel: "noopener",
                                class: "cdr-tt-social",
                                style: _normalizeStyle({ background: s.color }),
                                title: s.key
                              }, _toDisplayString(s.label), 13, _hoisted_37))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (contactDetail.value?.contact_inboxes?.[0])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _cache[81] || (_cache[81] = _createElementVNode("svg", {
                              width: "10",
                              height: "10",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(contactDetail.value.contact_inboxes[0].inbox.name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (tt.value.conv.team)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _cache[82] || (_cache[82] = _createElementVNode("svg", {
                              width: "10",
                              height: "10",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                              _createElementVNode("circle", {
                                cx: "9",
                                cy: "7",
                                r: "4"
                              }),
                              _createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }),
                              _createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(tt.value.conv.team.name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (tt.value.conv.labels.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tt.value.conv.labels, (l) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: l,
                                class: "cdr-tt-lbl"
                              }, _toDisplayString(l.replace(/_/g, ' ')), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["cdr-tt-dot", statusDot(tt.value.conv)])
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(statusLabel(tt.value.conv)) + " ", 1),
                        (tt.value.conv.unread_count)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(tt.value.conv.unread_count) + " não lida" + _toDisplayString(tt.value.conv.unread_count > 1 ? 's' : ''), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 4))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "cdr-panel" }, {
      default: _withCtx(() => [
        (panelVisible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "cdr-panel",
              style: _normalizeStyle({ width: panelWidth.value + 'px', right: STRIP_W + 'px' })
            }, [
              _createElementVNode("div", {
                class: "cdr-resize-handle",
                onMousedown: _withModifiers(startResize, ["prevent"])
              }, null, 32),
              (!chatOpen.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _cache[85] || (_cache[85] = _createElementVNode("svg", {
                          width: "13",
                          height: "13",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                        ], -1)),
                        _cache[86] || (_cache[86] = _createTextVNode(" Minhas Conversas ", -1)),
                        _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(myConvs).length), 1)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["cdr-auto-wrap", { 'cdr-auto-wrap--on': autoOpen.value }]),
                        title: autoOpen.value
              ? 'Auto-abrir ativo — quando o cliente enviar mensagem o chat abre automaticamente em janela flutuante'
              : 'Auto-abrir inativo — ative para abrir chats automaticamente quando o cliente enviar mensagem'
                      }, [
                        _cache[88] || (_cache[88] = _createElementVNode("svg", {
                          width: "11",
                          height: "11",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("polygon", { points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2" })
                        ], -1)),
                        _createElementVNode("label", {
                          class: "cdr-auto-sw",
                          onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((autoOpen).value = $event))
                          }, null, 512), [
                            [_vModelCheckbox, autoOpen.value]
                          ]),
                          _cache[87] || (_cache[87] = _createElementVNode("span", { class: "cdr-auto-track" }, null, -1))
                        ])
                      ], 10, _hoisted_46),
                      _createElementVNode("button", {
                        class: "cdr-icon-btn",
                        onClick: closePanel
                      }, [...(_cache[89] || (_cache[89] = [
                        _createElementVNode("svg", {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "3",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("line", {
                            x1: "18",
                            y1: "6",
                            x2: "6",
                            y2: "18"
                          }),
                          _createElementVNode("line", {
                            x1: "6",
                            y1: "6",
                            x2: "18",
                            y2: "18"
                          })
                        ], -1)
                      ]))])
                    ]),
                    (_unref(myConvs).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _cache[91] || (_cache[91] = _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("circle", {
                              cx: "11",
                              cy: "11",
                              r: "8"
                            }),
                            _createElementVNode("line", {
                              x1: "21",
                              y1: "21",
                              x2: "16.65",
                              y2: "16.65"
                            })
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((convSearch).value = $event)),
                            type: "text",
                            class: "cdr-search-input",
                            placeholder: "Buscar conversa…"
                          }, null, 512), [
                            [_vModelText, convSearch.value]
                          ]),
                          (convSearch.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "cdr-search-clear",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (convSearch.value = '')),
                                title: "Limpar busca"
                              }, [...(_cache[90] || (_cache[90] = [
                                _createElementVNode("svg", {
                                  width: "11",
                                  height: "11",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "3",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("line", {
                                    x1: "18",
                                    y1: "6",
                                    x2: "6",
                                    y2: "18"
                                  }),
                                  _createElementVNode("line", {
                                    x1: "6",
                                    y1: "6",
                                    x2: "18",
                                    y2: "18"
                                  })
                                ], -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (!_unref(myConvs).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [...(_cache[92] || (_cache[92] = [
                          _createElementVNode("svg", {
                            width: "40",
                            height: "40",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "1.3",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                          ], -1),
                          _createElementVNode("p", null, "Nenhuma conversa ativa atribuída a você", -1)
                        ]))]))
                      : (!filteredMyConvs.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _cache[93] || (_cache[93] = _createElementVNode("svg", {
                              width: "40",
                              height: "40",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.3",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("circle", {
                                cx: "11",
                                cy: "11",
                                r: "8"
                              }),
                              _createElementVNode("line", {
                                x1: "21",
                                y1: "21",
                                x2: "16.65",
                                y2: "16.65"
                              })
                            ], -1)),
                            _createElementVNode("p", null, "Nenhuma conversa encontrada para \"" + _toDisplayString(convSearch.value) + "\"", 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMyConvs.value, (conv) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: conv.id,
                                class: _normalizeClass(["cdr-item", { selected: selConvId.value === conv.id }]),
                                onClick: ($event: any) => (openChat(conv))
                              }, [
                                _createElementVNode("button", {
                                  class: "cdr-float-btn",
                                  onClick: _withModifiers(($event: any) => (_unref(floatOpen)(conv)), ["stop"]),
                                  title: "Abrir em janela flutuante"
                                }, [...(_cache[94] || (_cache[94] = [
                                  _createElementVNode("svg", {
                                    width: "11",
                                    height: "11",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("path", { d: "M15 3h6v6" }),
                                    _createElementVNode("path", { d: "M10 14L21 3" }),
                                    _createElementVNode("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" })
                                  ], -1)
                                ]))], 8, _hoisted_52),
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("div", {
                                    class: "cdr-item-av",
                                    style: _normalizeStyle({ background: _unref(avatarColor)(conv.contact.name) })
                                  }, [
                                    (conv.contact.thumbnail)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: conv.contact.thumbnail,
                                          alt: conv.contact.name,
                                          style: {"width":"100%","height":"100%","object-fit":"cover","border-radius":"50%"},
                                          onError: _cache[10] || (_cache[10] = (e) => (e.target as HTMLImageElement).style.display='none')
                                        }, null, 40, _hoisted_54))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_unref(initials)(conv.contact.name)), 1))
                                  ], 4),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["cdr-status-dot sm", statusDot(conv)])
                                  }, null, 2)
                                ]),
                                _createElementVNode("div", _hoisted_56, [
                                  _createElementVNode("div", _hoisted_57, [
                                    (conv.priority && conv.priority !== 'none')
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "cdr-item-prio",
                                          style: _normalizeStyle({ background: _unref(PRIORITY_COLORS)[conv.priority as Priority] + '22', color: _unref(PRIORITY_COLORS)[conv.priority as Priority], borderColor: _unref(PRIORITY_COLORS)[conv.priority as Priority] + '55' }),
                                          title: _unref(PRIORITY_LABELS)[conv.priority as Priority]
                                        }, [
                                          _createElementVNode("span", {
                                            class: "cdr-item-prio-dot",
                                            style: _normalizeStyle({ background: _unref(PRIORITY_COLORS)[conv.priority as Priority] })
                                          }, null, 4),
                                          _createTextVNode(" " + _toDisplayString(_unref(PRIORITY_LABELS)[conv.priority as Priority]), 1)
                                        ], 12, _hoisted_58))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", _hoisted_59, _toDisplayString(conv.contact.name), 1),
                                    _createElementVNode("span", _hoisted_60, _toDisplayString(convTime(conv)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_61, [
                                    _createElementVNode("span", _hoisted_62, _toDisplayString(previewText(conv.id)), 1),
                                    (conv.unread_count && !localReadConvIds.has(conv.id))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(conv.unread_count > 9 ? '9+' : conv.unread_count), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (conv.labels.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conv.labels.slice(0, 3), (l) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: l,
                                            class: "cdr-lbl"
                                          }, _toDisplayString(l.replace(/_/g, ' ')), 1))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (isAdmin.value && conv.assignee)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                        _cache[95] || (_cache[95] = _createElementVNode("svg", {
                                          width: "9",
                                          height: "9",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.5",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, [
                                          _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                                          _createElementVNode("circle", {
                                            cx: "12",
                                            cy: "7",
                                            r: "4"
                                          })
                                        ], -1)),
                                        _createTextVNode(" " + _toDisplayString(conv.assignee.name), 1)
                                      ]))
                                    : (isAdmin.value && !conv.assignee)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [...(_cache[96] || (_cache[96] = [
                                          _createElementVNode("svg", {
                                            width: "9",
                                            height: "9",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            "stroke-width": "2.5",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                          }, [
                                            _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                                            _createElementVNode("circle", {
                                              cx: "12",
                                              cy: "7",
                                              r: "4"
                                            })
                                          ], -1),
                                          _createTextVNode(" Sem agente ", -1)
                                        ]))]))
                                      : _createCommentVNode("", true),
                                  (conv.fluxo_id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_unref(fluxoLabel)(conv.fluxo_id)), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ], 10, _hoisted_51))
                            }), 128))
                          ]))
                  ], 64))
                : (activeConv.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("button", {
                          class: "cdr-icon-btn",
                          onClick: backToList,
                          title: "Voltar"
                        }, [...(_cache[97] || (_cache[97] = [
                          _createElementVNode("svg", {
                            width: "13",
                            height: "13",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "3",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                          ], -1)
                        ]))]),
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", {
                            class: "cdr-item-av sm2",
                            style: _normalizeStyle({ background: _unref(avatarColor)(activeConv.value.contact.name) })
                          }, [
                            (activeConv.value.contact.thumbnail)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: activeConv.value.contact.thumbnail,
                                  alt: activeConv.value.contact.name,
                                  style: {"width":"100%","height":"100%","object-fit":"cover","border-radius":"50%"},
                                  onError: _cache[11] || (_cache[11] = (e) => (e.target as HTMLImageElement).style.display='none')
                                }, null, 40, _hoisted_70))
                              : (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString(_unref(initials)(activeConv.value.contact.name)), 1))
                          ], 4),
                          _createElementVNode("span", {
                            class: _normalizeClass(["cdr-status-dot sm", statusDot(activeConv.value)]),
                            style: {"border-color":"#BC0C24"}
                          }, null, 2)
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("span", _hoisted_74, _toDisplayString(activeConv.value.contact.name), 1),
                            (activeConv.value.contact.phone)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_75, [
                                  _cache[100] || (_cache[100] = _createElementVNode("svg", {
                                    width: "9",
                                    height: "9",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13 19.79 19.79 0 0 1 1.61 4.44 2 2 0 0 1 3.59 2.24h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.29 6.29l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" })
                                  ], -1)),
                                  _createTextVNode(" " + _toDisplayString(_unref(fmtPhone)(activeConv.value.contact.phone)) + " ", 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["cdr-phone-copy-btn", { 'is-copied': phoneCopied.value }]),
                                    onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (copyPhone(activeConv.value.contact.phone)), ["stop"])),
                                    title: phoneCopied.value ? 'Copiado!' : 'Copiar número'
                                  }, [
                                    (phoneCopied.value)
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_77, [...(_cache[98] || (_cache[98] = [
                                          _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                        ]))]))
                                      : (_openBlock(), _createElementBlock("svg", _hoisted_78, [...(_cache[99] || (_cache[99] = [
                                          _createElementVNode("rect", {
                                            x: "9",
                                            y: "9",
                                            width: "13",
                                            height: "13",
                                            rx: "2"
                                          }, null, -1),
                                          _createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" }, null, -1)
                                        ]))]))
                                  ], 10, _hoisted_76)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (activeConvDocument.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(activeConvDocument.value.label) + ": " + _toDisplayString(activeConvDocument.value.value), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_80, [
                            (activeConv.value.team)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString(activeConv.value.team.name) + " · ", 1))
                              : _createCommentVNode("", true),
                            _createTextVNode("#" + _toDisplayString(activeConv.value.id) + " ", 1),
                            (activeConv.value.fluxo_id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(_unref(fluxoLabel)(activeConv.value.fluxo_id)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", {
                              class: _normalizeClass(['cdr-status-lbl', activeConv.value.status])
                            }, _toDisplayString(convStatusLabel(activeConv.value.status)), 3),
                            (activeSLABadge.value)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 2,
                                  class: _normalizeClass(['cdr-sla-badge', activeSLABadge.value.status])
                                }, [
                                  _cache[101] || (_cache[101] = _createElementVNode("svg", {
                                    width: "10",
                                    height: "10",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("circle", {
                                      cx: "12",
                                      cy: "12",
                                      r: "10"
                                    }),
                                    _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
                                  ], -1)),
                                  _createElementVNode("strong", null, _toDisplayString(activeSLABadge.value.time), 1),
                                  _createElementVNode("span", null, _toDisplayString(activeSLABadge.value.label), 1)
                                ], 2))
                              : _createCommentVNode("", true),
                            (activeConv.value.assignee)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_83, [
                                  _cache[102] || (_cache[102] = _createElementVNode("svg", {
                                    width: "9",
                                    height: "9",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                                    _createElementVNode("circle", {
                                      cx: "12",
                                      cy: "7",
                                      r: "4"
                                    })
                                  ], -1)),
                                  _createTextVNode(" " + _toDisplayString(activeConv.value.assignee.name), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_unref(can)('messages.changeStatus'))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "cdr-status-wrap",
                              onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createElementVNode("button", {
                                class: "cdr-icon-btn",
                                title: `Status: ${convStatusLabel(activeConv.value.status)}`,
                                onClick: _cache[13] || (_cache[13] = ($event: any) => {cdrStatusMenuOpen.value = !cdrStatusMenuOpen.value; cdrSnoozeMode.value = false})
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["cdr-s-dot", activeConv.value.status])
                                }, null, 2)
                              ], 8, _hoisted_84),
                              (cdrStatusMenuOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                    (!cdrSnoozeMode.value)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (activeConv.value.status !== 'open')
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "cdr-sopt",
                                                onClick: _cache[14] || (_cache[14] = ($event: any) => (cdrChangeStatus('open')))
                                              }, [...(_cache[103] || (_cache[103] = [
                                                _createElementVNode("span", { class: "cdr-s-dot open" }, null, -1),
                                                _createTextVNode(" Abrir ", -1)
                                              ]))]))
                                            : _createCommentVNode("", true),
                                          (activeConv.value.status !== 'resolved')
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                class: "cdr-sopt",
                                                onClick: _cache[15] || (_cache[15] = ($event: any) => (cdrChangeStatus('resolved')))
                                              }, [...(_cache[104] || (_cache[104] = [
                                                _createElementVNode("span", { class: "cdr-s-dot resolved" }, null, -1),
                                                _createTextVNode(" Resolver ", -1)
                                              ]))]))
                                            : _createCommentVNode("", true),
                                          (activeConv.value.status !== 'pending')
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                class: "cdr-sopt",
                                                onClick: _cache[16] || (_cache[16] = ($event: any) => (cdrChangeStatus('pending')))
                                              }, [...(_cache[105] || (_cache[105] = [
                                                _createElementVNode("span", { class: "cdr-s-dot pending" }, null, -1),
                                                _createTextVNode(" Pendente ", -1)
                                              ]))]))
                                            : _createCommentVNode("", true),
                                          (_unref(can)('messages.snooze'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 3,
                                                class: "cdr-sopt",
                                                onClick: _cache[17] || (_cache[17] = ($event: any) => (cdrSnoozeMode.value = true))
                                              }, [...(_cache[106] || (_cache[106] = [
                                                _createElementVNode("span", { class: "cdr-s-dot snoozed" }, null, -1),
                                                _createTextVNode(" Adiar… ", -1)
                                              ]))]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                          _cache[109] || (_cache[109] = _createElementVNode("div", { class: "cdr-snz-title" }, "Adiar por quanto tempo?", -1)),
                                          _createElementVNode("div", _hoisted_87, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "number",
                                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((cdrSnoozeH).value = $event)),
                                              min: "0",
                                              max: "99",
                                              class: "cdr-snz-inp"
                                            }, null, 512), [
                                              [
                                                _vModelText,
                                                cdrSnoozeH.value,
                                                void 0,
                                                { number: true }
                                              ]
                                            ]),
                                            _cache[107] || (_cache[107] = _createElementVNode("span", { class: "cdr-snz-lbl" }, "h", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                              type: "number",
                                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((cdrSnoozeM).value = $event)),
                                              min: "0",
                                              max: "59",
                                              class: "cdr-snz-inp"
                                            }, null, 512), [
                                              [
                                                _vModelText,
                                                cdrSnoozeM.value,
                                                void 0,
                                                { number: true }
                                              ]
                                            ]),
                                            _cache[108] || (_cache[108] = _createElementVNode("span", { class: "cdr-snz-lbl" }, "min", -1))
                                          ]),
                                          _cache[110] || (_cache[110] = _createElementVNode("div", { class: "cdr-snz-hint" }, "0h 0min = até próxima resposta", -1)),
                                          _createElementVNode("div", _hoisted_88, [
                                            _createElementVNode("button", {
                                              class: "cdr-snz-cancel",
                                              onClick: _cache[20] || (_cache[20] = ($event: any) => (cdrSnoozeMode.value = false))
                                            }, "Cancelar"),
                                            _createElementVNode("button", {
                                              class: "cdr-snz-confirm",
                                              onClick: cdrConfirmSnooze,
                                              disabled: cdrStatusLoading.value
                                            }, "Confirmar", 8, _hoisted_89)
                                          ])
                                        ]))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(can)('contacts.export'))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "cdr-icon-btn",
                              disabled: cdrExporting.value,
                              title: cdrExporting.value ? 'Exportando…' : 'Exportar conversa',
                              onClick: exportActiveConv
                            }, [
                              (!cdrExporting.value)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_91, [...(_cache[111] || (_cache[111] = [
                                    _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }, null, -1),
                                    _createElementVNode("polyline", { points: "7 10 12 15 17 10" }, null, -1),
                                    _createElementVNode("line", {
                                      x1: "12",
                                      y1: "15",
                                      x2: "12",
                                      y2: "3"
                                    }, null, -1)
                                  ]))]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_92))
                            ], 8, _hoisted_90))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "cdr-icon-btn",
                          onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_unref(openMsgSearch) && _unref(openMsgSearch)(...args))),
                          title: "Buscar nas mensagens"
                        }, [...(_cache[112] || (_cache[112] = [
                          _createElementVNode("svg", {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.8",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("circle", {
                              cx: "11",
                              cy: "11",
                              r: "8"
                            }),
                            _createElementVNode("line", {
                              x1: "21",
                              y1: "21",
                              x2: "16.65",
                              y2: "16.65"
                            })
                          ], -1)
                        ]))]),
                        (_unref(can)('messages.runMacro'))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: _normalizeClass(["cdr-icon-btn", { 'cdr-icon-btn--active': cdrMacroPanelOpen.value }]),
                              onClick: toggleCdrMacroPanel,
                              title: cdrMacroPanelOpen.value ? 'Voltar à conversa' : 'Executar macro'
                            }, [
                              (!cdrMacroPanelOpen.value)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_94, [...(_cache[113] || (_cache[113] = [
                                    _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" }, null, -1)
                                  ]))]))
                                : (_openBlock(), _createElementBlock("svg", _hoisted_95, [...(_cache[114] || (_cache[114] = [
                                    _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" }, null, -1)
                                  ]))]))
                            ], 10, _hoisted_93))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "cdr-icon-btn",
                          onClick: closePanel,
                          title: "Fechar conversa"
                        }, [...(_cache[115] || (_cache[115] = [
                          _createElementVNode("svg", {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "3",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("line", {
                              x1: "18",
                              y1: "6",
                              x2: "6",
                              y2: "18"
                            }),
                            _createElementVNode("line", {
                              x1: "6",
                              y1: "6",
                              x2: "18",
                              y2: "18"
                            })
                          ], -1)
                        ]))])
                      ]),
                      _createElementVNode("div", _hoisted_96, [
                        (_unref(can)('messages.assignAgent'))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "cdr-agent-wrap",
                              onClick: _cache[30] || (_cache[30] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              (currentAssignee.value)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "cdr-agent-sel",
                                    onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (agentMenuOpen.value = !agentMenuOpen.value), ["stop"])),
                                    title: "Mudar agente"
                                  }, [
                                    _cache[116] || (_cache[116] = _createElementVNode("svg", {
                                      width: "8",
                                      height: "8",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                                      _createElementVNode("circle", {
                                        cx: "12",
                                        cy: "7",
                                        r: "4"
                                      })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(currentAssignee.value.name), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "cdr-lbl-add-btn",
                                    onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (agentMenuOpen.value = !agentMenuOpen.value), ["stop"]))
                                  }, [...(_cache[117] || (_cache[117] = [
                                    _createElementVNode("svg", {
                                      width: "8",
                                      height: "8",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                                      _createElementVNode("circle", {
                                        cx: "12",
                                        cy: "7",
                                        r: "4"
                                      })
                                    ], -1),
                                    _createTextVNode(" agente ", -1)
                                  ]))])),
                              (agentMenuOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                    _createElementVNode("div", _hoisted_98, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((agentSearch).value = $event)),
                                        class: "cdr-agent-search",
                                        placeholder: "Buscar agente…",
                                        onClick: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["stop"])),
                                        onKeydown: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["stop"]))
                                      }, null, 544), [
                                        [_vModelText, agentSearch.value]
                                      ])
                                    ]),
                                    (agentLoading.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [...(_cache[118] || (_cache[118] = [
                                          _createElementVNode("div", {
                                            class: "cdr-spinner",
                                            style: {"width":"14px","height":"14px","border-width":"2px"}
                                          }, null, -1)
                                        ]))]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                          _createElementVNode("button", {
                                            class: _normalizeClass(["cdr-agent-opt", { active: !currentAssignee.value }]),
                                            onClick: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (doAssignAgent(null)), ["stop"]))
                                          }, [
                                            _cache[120] || (_cache[120] = _createElementVNode("div", {
                                              class: "cdr-agent-av",
                                              style: {"background":"var(--ink-10)","color":"var(--ink-50)","font-size":"10px"}
                                            }, "—", -1)),
                                            _cache[121] || (_cache[121] = _createTextVNode(" Sem agente ", -1)),
                                            (!currentAssignee.value)
                                              ? (_openBlock(), _createElementBlock("svg", _hoisted_101, [...(_cache[119] || (_cache[119] = [
                                                  _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                                ]))]))
                                              : _createCommentVNode("", true)
                                          ], 2),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAgents.value, (a) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                              key: a.id,
                                              class: _normalizeClass(["cdr-agent-opt", { active: currentAssignee.value?.id === a.id }]),
                                              onClick: _withModifiers(($event: any) => (doAssignAgent(a.id)), ["stop"])
                                            }, [
                                              _createElementVNode("div", {
                                                class: "cdr-agent-av-wrap",
                                                title: availLabel(agentStatusOf(a.id))
                                              }, [
                                                _createElementVNode("div", {
                                                  class: "cdr-agent-av",
                                                  style: _normalizeStyle({ background: _unref(avatarColor)(a.name), overflow:'hidden' })
                                                }, [
                                                  (a.thumbnail)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: a.thumbnail,
                                                        alt: a.name,
                                                        style: {"width":"100%","height":"100%","object-fit":"cover","border-radius":"50%","display":"block"},
                                                        onError: _cache[29] || (_cache[29] = (e) => (e.target as HTMLImageElement).style.display='none')
                                                      }, null, 40, _hoisted_104))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_105, _toDisplayString(_unref(initials)(a.name)), 1))
                                                ], 4),
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["cdr-agent-status-dot", `casd-${agentStatusOf(a.id)}`])
                                                }, null, 2)
                                              ], 8, _hoisted_103),
                                              _createTextVNode(" " + _toDisplayString(a.name) + " ", 1),
                                              (currentAssignee.value?.id === a.id)
                                                ? (_openBlock(), _createElementBlock("svg", _hoisted_106, [...(_cache[122] || (_cache[122] = [
                                                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                                  ]))]))
                                                : _createCommentVNode("", true)
                                            ], 10, _hoisted_102))
                                          }), 128))
                                        ]))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (canAssignTeam.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "cdr-agent-wrap",
                              onClick: _cache[37] || (_cache[37] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              (currentTeam.value)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "cdr-agent-sel",
                                    onClick: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (cdrTeamMenuOpen.value = !cdrTeamMenuOpen.value), ["stop"])),
                                    title: "Mudar time"
                                  }, [
                                    _cache[123] || (_cache[123] = _createElementVNode("svg", {
                                      width: "8",
                                      height: "8",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                                      _createElementVNode("circle", {
                                        cx: "9",
                                        cy: "7",
                                        r: "4"
                                      }),
                                      _createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }),
                                      _createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(currentTeam.value.name), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "cdr-lbl-add-btn",
                                    onClick: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (cdrTeamMenuOpen.value = !cdrTeamMenuOpen.value), ["stop"]))
                                  }, [...(_cache[124] || (_cache[124] = [
                                    _createElementVNode("svg", {
                                      width: "8",
                                      height: "8",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2.5",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                                      _createElementVNode("circle", {
                                        cx: "9",
                                        cy: "7",
                                        r: "4"
                                      }),
                                      _createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }),
                                      _createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
                                    ], -1),
                                    _createTextVNode(" time ", -1)
                                  ]))])),
                              (cdrTeamMenuOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                    _createElementVNode("div", _hoisted_108, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((cdrTeamSearch).value = $event)),
                                        class: "cdr-agent-search",
                                        placeholder: "Buscar time…",
                                        onClick: _cache[34] || (_cache[34] = _withModifiers(() => {}, ["stop"])),
                                        onKeydown: _cache[35] || (_cache[35] = _withModifiers(() => {}, ["stop"]))
                                      }, null, 544), [
                                        [_vModelText, cdrTeamSearch.value]
                                      ])
                                    ]),
                                    (cdrTeamsLoading.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_109, [...(_cache[125] || (_cache[125] = [
                                          _createElementVNode("div", {
                                            class: "cdr-spinner",
                                            style: {"width":"14px","height":"14px","border-width":"2px"}
                                          }, null, -1)
                                        ]))]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                          _createElementVNode("button", {
                                            class: _normalizeClass(["cdr-agent-opt", { active: !currentTeam.value }]),
                                            onClick: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (doAssignCdrTeam(null)), ["stop"]))
                                          }, [
                                            _cache[127] || (_cache[127] = _createElementVNode("div", {
                                              class: "cdr-agent-av",
                                              style: {"background":"var(--ink-10)","color":"var(--ink-50)","font-size":"10px"}
                                            }, "—", -1)),
                                            _cache[128] || (_cache[128] = _createTextVNode(" Sem time ", -1)),
                                            (!currentTeam.value)
                                              ? (_openBlock(), _createElementBlock("svg", _hoisted_111, [...(_cache[126] || (_cache[126] = [
                                                  _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                                ]))]))
                                              : _createCommentVNode("", true)
                                          ], 2),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCdrTeams.value, (t) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                              key: t.id,
                                              class: _normalizeClass(["cdr-agent-opt", { active: currentTeam.value?.id === t.id }]),
                                              onClick: _withModifiers(($event: any) => (doAssignCdrTeam(t.id)), ["stop"])
                                            }, [
                                              _createElementVNode("div", {
                                                class: "cdr-agent-av",
                                                style: _normalizeStyle({ background: _unref(avatarColor)(t.name) })
                                              }, _toDisplayString(_unref(initials)(t.name)), 5),
                                              _createTextVNode(" " + _toDisplayString(t.name) + " ", 1),
                                              (currentTeam.value?.id === t.id)
                                                ? (_openBlock(), _createElementBlock("svg", _hoisted_113, [...(_cache[129] || (_cache[129] = [
                                                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                                  ]))]))
                                                : _createCommentVNode("", true)
                                            ], 10, _hoisted_112))
                                          }), 128))
                                        ]))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(can)('messages.setPriority'))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "cdr-priority-wrap",
                              onClick: _cache[40] || (_cache[40] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              (currentPriority.value)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "cdr-priority-tag",
                                    style: _normalizeStyle({ background: _unref(PRIORITY_COLORS)[currentPriority.value] + '20', color: _unref(PRIORITY_COLORS)[currentPriority.value], borderColor: _unref(PRIORITY_COLORS)[currentPriority.value] + '55' }),
                                    onClick: _cache[38] || (_cache[38] = _withModifiers(($event: any) => (priorityMenuOpen.value = !priorityMenuOpen.value), ["stop"])),
                                    title: `Prioridade: ${_unref(PRIORITY_LABELS)[currentPriority.value]}`
                                  }, [
                                    (_openBlock(), _createElementBlock("svg", _hoisted_115, [...(_cache[130] || (_cache[130] = [
                                      _createElementVNode("path", { d: "M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" }, null, -1)
                                    ]))])),
                                    _createTextVNode(" " + _toDisplayString(_unref(PRIORITY_LABELS)[currentPriority.value]) + " ", 1),
                                    (priorityLoading.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_116))
                                      : _createCommentVNode("", true)
                                  ], 12, _hoisted_114))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "cdr-lbl-add-btn cdr-priority-add",
                                    onClick: _cache[39] || (_cache[39] = _withModifiers(($event: any) => (priorityMenuOpen.value = !priorityMenuOpen.value), ["stop"])),
                                    disabled: priorityLoading.value
                                  }, [
                                    (!priorityLoading.value)
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_118, [...(_cache[131] || (_cache[131] = [
                                          _createElementVNode("path", { d: "M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" }, null, -1)
                                        ]))]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_119)),
                                    _cache[132] || (_cache[132] = _createTextVNode(" prioridade ", -1))
                                  ], 8, _hoisted_117)),
                              (priorityMenuOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList((['urgent','high','medium','low','none'] as const), (p) => {
                                      return _createElementVNode("button", {
                                        key: p,
                                        class: _normalizeClass(["cdr-priority-opt", { active: currentPriority.value === p || (!currentPriority.value && p === 'none') }]),
                                        onClick: _withModifiers(($event: any) => (doTogglePriority(p)), ["stop"])
                                      }, [
                                        (p !== 'none')
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              class: "cdr-priority-dot",
                                              style: _normalizeStyle({ background: _unref(PRIORITY_COLORS)[p] })
                                            }, null, 4))
                                          : (_openBlock(), _createElementBlock("svg", _hoisted_122, [...(_cache[133] || (_cache[133] = [
                                              _createElementVNode("line", {
                                                x1: "5",
                                                y1: "12",
                                                x2: "19",
                                                y2: "12"
                                              }, null, -1)
                                            ]))])),
                                        _createTextVNode(" " + _toDisplayString(_unref(PRIORITY_LABELS)[p]) + " ", 1),
                                        (currentPriority.value === p || (!currentPriority.value && p === 'none'))
                                          ? (_openBlock(), _createElementBlock("svg", _hoisted_123, [...(_cache[134] || (_cache[134] = [
                                              _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                            ]))]))
                                          : _createCommentVNode("", true)
                                      ], 10, _hoisted_121)
                                    }), 64))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentLabels.value, (l) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: l,
                            class: "cdr-lbl cdr-lbl-active"
                          }, [
                            _createTextVNode(_toDisplayString(l.replace(/_/g, ' ')) + " ", 1),
                            (!_unref(isLabelProtected)(l))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "cdr-lbl-x",
                                  onClick: _withModifiers(($event: any) => (toggleLabel(l)), ["stop"]),
                                  disabled: updatingLabels.value
                                }, "×", 8, _hoisted_124))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_125, [...(_cache[135] || (_cache[135] = [
                                  _createElementVNode("rect", {
                                    x: "3",
                                    y: "11",
                                    width: "18",
                                    height: "11",
                                    rx: "2"
                                  }, null, -1),
                                  _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }, null, -1)
                                ]))]))
                          ]))
                        }), 128)),
                        _createElementVNode("div", _hoisted_126, [
                          _createElementVNode("button", {
                            class: "cdr-lbl-add-btn",
                            onClick: _cache[41] || (_cache[41] = _withModifiers(($event: any) => (labelsOpen.value = !labelsOpen.value), ["stop"])),
                            disabled: updatingLabels.value
                          }, [...(_cache[136] || (_cache[136] = [
                            _createElementVNode("svg", {
                              width: "9",
                              height: "9",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "3.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("line", {
                                x1: "12",
                                y1: "5",
                                x2: "12",
                                y2: "19"
                              }),
                              _createElementVNode("line", {
                                x1: "5",
                                y1: "12",
                                x2: "19",
                                y2: "12"
                              })
                            ], -1),
                            _createTextVNode(" etiqueta ", -1)
                          ]))], 8, _hoisted_127),
                          (labelsOpen.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                (!allLabels.value.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_129, [...(_cache[137] || (_cache[137] = [
                                      _createElementVNode("span", {
                                        class: "cdr-spinner",
                                        style: {"width":"14px","height":"14px","border-width":"2px"}
                                      }, null, -1)
                                    ]))]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allLabels.value, (lbl) => {
                                  return (_openBlock(), _createElementBlock("label", {
                                    key: lbl.id,
                                    class: _normalizeClass(["cdr-lbl-opt", { checked: currentLabels.value.includes(lbl.title) }]),
                                    onClick: _withModifiers(($event: any) => ((currentLabels.value.includes(lbl.title) && _unref(isLabelProtected)(lbl.title)) || toggleLabel(lbl.title)), ["prevent"])
                                  }, [
                                    _createElementVNode("span", {
                                      class: "cdr-lbl-dot",
                                      style: _normalizeStyle({ background: lbl.color })
                                    }, null, 4),
                                    _createElementVNode("span", _hoisted_131, _toDisplayString(lbl.title.replace(/_/g, ' ')), 1),
                                    (currentLabels.value.includes(lbl.title) && _unref(isLabelProtected)(lbl.title))
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_132, [...(_cache[138] || (_cache[138] = [
                                          _createElementVNode("rect", {
                                            x: "3",
                                            y: "11",
                                            width: "18",
                                            height: "11",
                                            rx: "2"
                                          }, null, -1),
                                          _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }, null, -1)
                                        ]))]))
                                      : (currentLabels.value.includes(lbl.title))
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_133, [...(_cache[139] || (_cache[139] = [
                                            _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                          ]))]))
                                        : _createCommentVNode("", true)
                                  ], 10, _hoisted_130))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (activeConv.value.status === 'snoozed')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                            _cache[140] || (_cache[140] = _createElementVNode("svg", {
                              width: "11",
                              height: "11",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "12",
                                r: "10"
                              }),
                              _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
                            ], -1)),
                            (cdrSnoozeRemainingLabel.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_135, "Adiado — " + _toDisplayString(cdrSnoozeRemainingLabel.value) + " restantes", 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_136, "Adiado até próxima resposta do cliente"))
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(cdrWindowClosed))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_137, [...(_cache[141] || (_cache[141] = [
                            _createElementVNode("svg", {
                              width: "13",
                              height: "13",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "12",
                                r: "10"
                              }),
                              _createElementVNode("line", {
                                x1: "12",
                                y1: "8",
                                x2: "12",
                                y2: "12"
                              }),
                              _createElementVNode("line", {
                                x1: "12",
                                y1: "16",
                                x2: "12.01",
                                y2: "16"
                              })
                            ], -1),
                            _createElementVNode("span", null, "Você só pode responder a esta conversa usando um template devido à janela de mensagens de 24 horas do WhatsApp", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      (_unref(msgSearchOpen))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                            _withDirectives(_createElementVNode("input", {
                              ref_key: "msgSearchInputEl",
                              ref: msgSearchInputEl,
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_isRef(msgSearchQuery) ? (msgSearchQuery).value = $event : null)),
                              class: "cdr-msg-search-input",
                              placeholder: "Buscar nas mensagens…",
                              onKeydown: [
                                _cache[43] || (_cache[43] = _withKeys(
//@ts-ignore
(...args) => (_unref(doMsgSearch) && _unref(doMsgSearch)(...args)), ["enter"])),
                                _cache[44] || (_cache[44] = _withKeys(
//@ts-ignore
(...args) => (_unref(closeMsgSearch) && _unref(closeMsgSearch)(...args)), ["escape"]))
                              ]
                            }, null, 544), [
                              [_vModelText, _unref(msgSearchQuery)]
                            ]),
                            (_unref(msgSearchActive))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_139, _toDisplayString(_unref(msgMatchIds).length ? (_unref(msgCurrentIdx) + 1) + '/' + _unref(msgMatchIds).length : '0 resultados'), 1))
                              : _createCommentVNode("", true),
                            (_unref(msgMatchIds).length)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "cdr-msg-search-nav",
                                  onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_unref(goPrevMsg) && _unref(goPrevMsg)(...args))),
                                  title: "Anterior"
                                }, [...(_cache[142] || (_cache[142] = [
                                  _createElementVNode("svg", {
                                    width: "10",
                                    height: "10",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("polyline", { points: "18 15 12 9 6 15" })
                                  ], -1)
                                ]))]))
                              : _createCommentVNode("", true),
                            (_unref(msgMatchIds).length)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  class: "cdr-msg-search-nav",
                                  onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_unref(goNextMsg) && _unref(goNextMsg)(...args))),
                                  title: "Próximo"
                                }, [...(_cache[143] || (_cache[143] = [
                                  _createElementVNode("svg", {
                                    width: "10",
                                    height: "10",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                                  ], -1)
                                ]))]))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              class: "cdr-msg-search-close",
                              onClick: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_unref(closeMsgSearch) && _unref(closeMsgSearch)(...args)))
                            }, [...(_cache[144] || (_cache[144] = [
                              _createElementVNode("svg", {
                                width: "10",
                                height: "10",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("line", {
                                  x1: "18",
                                  y1: "6",
                                  x2: "6",
                                  y2: "18"
                                }),
                                _createElementVNode("line", {
                                  x1: "6",
                                  y1: "6",
                                  x2: "18",
                                  y2: "18"
                                })
                              ], -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (cdrMacroPanelOpen.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                            (cdrMacroFormTarget.value && !cdrMacroRunning.value && !cdrMacroRunDone.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", _hoisted_141, [
                                    _createElementVNode("button", {
                                      class: "cdr-macro-back",
                                      onClick: _cache[48] || (_cache[48] = ($event: any) => (cdrMacroFormTarget.value = null))
                                    }, [...(_cache[145] || (_cache[145] = [
                                      _createElementVNode("svg", {
                                        width: "11",
                                        height: "11",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2.5",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                      }, [
                                        _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                                      ], -1),
                                      _createTextVNode(" Voltar ", -1)
                                    ]))]),
                                    _createElementVNode("span", _hoisted_142, _toDisplayString(cdrMacroFormTarget.value.name), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_143, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cdrMacroFormActions.value, (fa, cardIdx) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: fa.idx,
                                        class: "cdr-mform-card"
                                      }, [
                                        _createElementVNode("div", _hoisted_144, [
                                          _createElementVNode("span", _hoisted_145, _toDisplayString(cardIdx + 1), 1),
                                          _createElementVNode("div", _hoisted_146, [
                                            _cache[146] || (_cache[146] = _createElementVNode("span", { class: "cdr-mform-card-title" }, "Webhook com Formulário", -1)),
                                            (fa.url)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_147, _toDisplayString(fa.url), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _cache[147] || (_cache[147] = _createElementVNode("p", { class: "cdr-mform-hint" }, "Preencha os campos antes de executar", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fa.fields, (field) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: field.key,
                                            class: "cdr-mform-field"
                                          }, [
                                            _createElementVNode("label", _hoisted_148, _toDisplayString(field.label || field.key), 1),
                                            _withDirectives(_createElementVNode("input", {
                                              class: "cdr-mform-input",
                                              "onUpdate:modelValue": ($event: any) => ((cdrMacroFormValues.value[fa.idx][field.key]) = $event),
                                              placeholder: field.label || field.key,
                                              type: "text"
                                            }, null, 8, _hoisted_149), [
                                              [_vModelText, cdrMacroFormValues.value[fa.idx][field.key]]
                                            ])
                                          ]))
                                        }), 128))
                                      ]))
                                    }), 128)),
                                    _createElementVNode("div", { class: "cdr-mform-btns" }, [
                                      _createElementVNode("button", {
                                        class: "cdr-mform-submit",
                                        onClick: submitCdrMacroForm
                                      }, [...(_cache[148] || (_cache[148] = [
                                        _createElementVNode("svg", {
                                          width: "11",
                                          height: "11",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.5",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, [
                                          _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" })
                                        ], -1),
                                        _createTextVNode(" Executar ", -1)
                                      ]))])
                                    ])
                                  ])
                                ], 64))
                              : (!cdrMacroRunning.value && !cdrMacroRunDone.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", _hoisted_150, [
                                      _createElementVNode("div", _hoisted_151, [
                                        _cache[149] || (_cache[149] = _createElementVNode("svg", {
                                          width: "11",
                                          height: "11",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.5",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, [
                                          _createElementVNode("circle", {
                                            cx: "11",
                                            cy: "11",
                                            r: "8"
                                          }),
                                          _createElementVNode("line", {
                                            x1: "21",
                                            y1: "21",
                                            x2: "16.65",
                                            y2: "16.65"
                                          })
                                        ], -1)),
                                        _withDirectives(_createElementVNode("input", {
                                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((cdrMacroSearch).value = $event)),
                                          class: "cdr-macro-search",
                                          placeholder: "Buscar macro…"
                                        }, null, 512), [
                                          [_vModelText, cdrMacroSearch.value]
                                        ])
                                      ]),
                                      _createElementVNode("span", _hoisted_152, _toDisplayString(cdrFilteredMacros.value.length) + " macro" + _toDisplayString(cdrFilteredMacros.value.length !== 1 ? 's' : ''), 1)
                                    ]),
                                    (cdrMacrosLoading.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_153, [...(_cache[150] || (_cache[150] = [
                                          _createElementVNode("span", { class: "cdr-spinner" }, null, -1)
                                        ]))]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cdrFilteredMacros.value, (m) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                              key: m.id,
                                              class: "cdr-macro-item",
                                              onClick: ($event: any) => (runCdrMacro(m))
                                            }, [
                                              _createElementVNode("div", _hoisted_156, [
                                                _createElementVNode("span", _hoisted_157, _toDisplayString(m.name), 1),
                                                _createElementVNode("span", _hoisted_158, _toDisplayString(m.actions.length) + " ação" + _toDisplayString(m.actions.length !== 1 ? 'ões' : ''), 1)
                                              ]),
                                              _cache[151] || (_cache[151] = _createElementVNode("svg", {
                                                width: "11",
                                                height: "11",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2.5",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round"
                                              }, [
                                                _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" })
                                              ], -1))
                                            ], 8, _hoisted_155))
                                          }), 128)),
                                          (!cdrFilteredMacros.value.length && !cdrMacrosLoading.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_159, "Nenhuma macro encontrada"))
                                            : _createCommentVNode("", true)
                                        ]))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createElementVNode("div", _hoisted_160, [
                                      (cdrMacroRunDone.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "cdr-macro-back",
                                            onClick: resetCdrMacroRun
                                          }, [...(_cache[152] || (_cache[152] = [
                                            _createElementVNode("svg", {
                                              width: "11",
                                              height: "11",
                                              viewBox: "0 0 24 24",
                                              fill: "none",
                                              stroke: "currentColor",
                                              "stroke-width": "2.5",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round"
                                            }, [
                                              _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                                            ], -1),
                                            _createTextVNode(" Voltar ", -1)
                                          ]))]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("span", _hoisted_161, _toDisplayString(cdrMacroRunningObj.value?.name), 1),
                                      (cdrMacroRunning.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_162))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_163, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cdrMacroStepResults.value, (step, i) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: i,
                                          class: _normalizeClass(["cdr-macro-step", step.ok ? 'cdr-macro-step--ok' : 'cdr-macro-step--err'])
                                        }, [
                                          (step.ok)
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_164, [...(_cache[153] || (_cache[153] = [
                                                _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                              ]))]))
                                            : (_openBlock(), _createElementBlock("svg", _hoisted_165, [...(_cache[154] || (_cache[154] = [
                                                _createElementVNode("line", {
                                                  x1: "18",
                                                  y1: "6",
                                                  x2: "6",
                                                  y2: "18"
                                                }, null, -1),
                                                _createElementVNode("line", {
                                                  x1: "6",
                                                  y1: "6",
                                                  x2: "18",
                                                  y2: "18"
                                                }, null, -1)
                                              ]))])),
                                          _createElementVNode("span", _hoisted_166, _toDisplayString(step.label), 1),
                                          (!step.ok)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_167, _toDisplayString(step.msg), 1))
                                            : _createCommentVNode("", true)
                                        ], 2))
                                      }), 128))
                                    ]),
                                    (cdrMacroRunDone.value)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: _normalizeClass(["cdr-macro-summary", cdrMacroStepResults.value.some(s => !s.ok) ? 'cdr-macro-summary--warn' : 'cdr-macro-summary--ok'])
                                        }, [
                                          (!cdrMacroStepResults.value.some(s => !s.ok))
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_168, [...(_cache[155] || (_cache[155] = [
                                                _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                              ]))]))
                                            : (_openBlock(), _createElementBlock("svg", _hoisted_169, [...(_cache[156] || (_cache[156] = [
                                                _createElementVNode("circle", {
                                                  cx: "12",
                                                  cy: "12",
                                                  r: "10"
                                                }, null, -1),
                                                _createElementVNode("line", {
                                                  x1: "12",
                                                  y1: "8",
                                                  x2: "12",
                                                  y2: "12"
                                                }, null, -1),
                                                _createElementVNode("line", {
                                                  x1: "12",
                                                  y1: "16",
                                                  x2: "12.01",
                                                  y2: "16"
                                                }, null, -1)
                                              ]))])),
                                          _createTextVNode(" " + _toDisplayString(cdrMacroStepResults.value.some(s => !s.ok) ? cdrMacroStepResults.value.filter(s => !s.ok).length + ' ação(ões) com erro' : 'Concluído com sucesso!'), 1)
                                        ], 2))
                                      : _createCommentVNode("", true)
                                  ], 64))
                          ]))
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("div", {
                        class: "cdr-msgs",
                        ref_key: "msgsEl",
                        ref: msgsEl,
                        onScroll: onMsgsScroll
                      }, [
                        (loadingMsgs.value || _unref(msgSearchLoading))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                              (_unref(msgSearchLoading))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[157] || (_cache[157] = _createElementVNode("span", { class: "cdr-spinner" }, null, -1)),
                                    _cache[158] || (_cache[158] = _createElementVNode("span", { class: "cdr-msgs-loading-label" }, "Buscando em toda a conversa…", -1))
                                  ], 64))
                                : (_openBlock(), _createElementBlock("div", _hoisted_171, [...(_cache[159] || (_cache[159] = [
                                    _createElementVNode("div", { class: "cdr-sk-row inn" }, [
                                      _createElementVNode("div", {
                                        class: "cdr-sk-bubble",
                                        style: {"width":"58%"}
                                      })
                                    ], -1),
                                    _createElementVNode("div", { class: "cdr-sk-row inn" }, [
                                      _createElementVNode("div", {
                                        class: "cdr-sk-bubble",
                                        style: {"width":"36%"}
                                      })
                                    ], -1),
                                    _createElementVNode("div", { class: "cdr-sk-row out" }, [
                                      _createElementVNode("div", {
                                        class: "cdr-sk-bubble",
                                        style: {"width":"46%"}
                                      })
                                    ], -1),
                                    _createElementVNode("div", { class: "cdr-sk-row inn" }, [
                                      _createElementVNode("div", {
                                        class: "cdr-sk-bubble",
                                        style: {"width":"64%"}
                                      })
                                    ], -1),
                                    _createElementVNode("div", { class: "cdr-sk-row out" }, [
                                      _createElementVNode("div", {
                                        class: "cdr-sk-bubble",
                                        style: {"width":"30%"}
                                      })
                                    ], -1)
                                  ]))]))
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (loadingMore.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_172, [...(_cache[160] || (_cache[160] = [
                                    _createElementVNode("span", { class: "cdr-spinner-sm" }, null, -1)
                                  ]))]))
                                : (noMoreMsgs.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_173, "início da conversa"))
                                  : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedMsgs.value, (msg) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: msg.id,
                                  class: _normalizeClass(["cdr-msg-row", { out: msg.message_type === 1, inn: msg.message_type === 0, act: msg.message_type === 2, 'msg-match-current': _unref(msgSearchActive) && _unref(msgMatchIds)[_unref(msgCurrentIdx)] === msg.id }]),
                                  "data-msg-id": msg.id
                                }, [
                                  (msg.message_type === 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_175, _toDisplayString(msg.content), 1))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (msg.showAvatar)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "cdr-msg-av",
                                              style: _normalizeStyle({ background: _unref(avatarColor)(senderName(msg)) }),
                                              title: senderName(msg)
                                            }, [
                                              (msg.sender?.thumbnail && msg.message_type === 1)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: msg.sender.thumbnail,
                                                    alt: senderName(msg),
                                                    onError: _cache[50] || (_cache[50] = (e) => (e.target as HTMLImageElement).style.display='none')
                                                  }, null, 40, _hoisted_177))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_178, _toDisplayString(_unref(initials)(senderName(msg))), 1))
                                            ], 12, _hoisted_176))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_179)),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["cdr-bubble", { 'cdr-bubble--priv': msg.private }])
                                        }, [
                                          (msg.private)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_180, [...(_cache[161] || (_cache[161] = [
                                                _createElementVNode("svg", {
                                                  width: "10",
                                                  height: "10",
                                                  viewBox: "0 0 24 24",
                                                  fill: "none",
                                                  stroke: "currentColor",
                                                  "stroke-width": "2.5",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round"
                                                }, [
                                                  _createElementVNode("rect", {
                                                    x: "3",
                                                    y: "11",
                                                    width: "18",
                                                    height: "11",
                                                    rx: "2"
                                                  }),
                                                  _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
                                                ], -1),
                                                _createTextVNode(" Nota interna ", -1)
                                              ]))]))
                                            : _createCommentVNode("", true),
                                          (msg.content)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 1,
                                                class: "cdr-bubble-text",
                                                innerHTML: _unref(highlightMsgHtml)(msg.content, msg.message_type === 1, authUser.value?.message_signature)
                                              }, null, 8, _hoisted_181))
                                            : _createCommentVNode("", true),
                                          (msg.message_type === 1 && _unref(extractFileKey)(msg.content || ''))
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 2,
                                                href: _unref(n8nDownloadUrl)(_unref(extractFileKey)(msg.content || '')),
                                                target: "_blank",
                                                rel: "noopener",
                                                class: "cdr-file-dl-btn"
                                              }, [...(_cache[162] || (_cache[162] = [
                                                _createElementVNode("svg", {
                                                  width: "11",
                                                  height: "11",
                                                  viewBox: "0 0 24 24",
                                                  fill: "none",
                                                  stroke: "currentColor",
                                                  "stroke-width": "2.5",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round"
                                                }, [
                                                  _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                                                  _createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
                                                  _createElementVNode("line", {
                                                    x1: "12",
                                                    y1: "15",
                                                    x2: "12",
                                                    y2: "3"
                                                  })
                                                ], -1),
                                                _createTextVNode(" Baixar arquivo ", -1)
                                              ]))], 8, _hoisted_182))
                                            : _createCommentVNode("", true),
                                          (msg.attachments?.length)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(msg.attachments, (att) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: att.id,
                                                  class: "cdr-att"
                                                }, [
                                                  (att.file_type === 'image')
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 0,
                                                        href: att.data_url,
                                                        target: "_blank",
                                                        rel: "noopener",
                                                        class: "cdr-att-img-wrap"
                                                      }, [
                                                        _createElementVNode("img", {
                                                          src: att.thumb_url || att.data_url,
                                                          class: "cdr-att-img",
                                                          alt: "imagem",
                                                          loading: "lazy"
                                                        }, null, 8, _hoisted_184)
                                                      ], 8, _hoisted_183))
                                                    : (att.file_type === 'audio')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                                          _createElementVNode("button", {
                                                            class: "cdr-ap-btn",
                                                            onClick: ($event: any) => (_unref(toggleAudio)(att))
                                                          }, [
                                                            (_unref(audioState)[att.id]?.playing)
                                                              ? (_openBlock(), _createElementBlock("svg", _hoisted_187, [...(_cache[163] || (_cache[163] = [
                                                                  _createElementVNode("rect", {
                                                                    x: "6",
                                                                    y: "4",
                                                                    width: "4",
                                                                    height: "16"
                                                                  }, null, -1),
                                                                  _createElementVNode("rect", {
                                                                    x: "14",
                                                                    y: "4",
                                                                    width: "4",
                                                                    height: "16"
                                                                  }, null, -1)
                                                                ]))]))
                                                              : (_openBlock(), _createElementBlock("svg", _hoisted_188, [...(_cache[164] || (_cache[164] = [
                                                                  _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" }, null, -1)
                                                                ]))]))
                                                          ], 8, _hoisted_186),
                                                          _createElementVNode("div", _hoisted_189, [
                                                            _createElementVNode("div", {
                                                              class: "cdr-ap-bar",
                                                              onClick: _cache[51] || (_cache[51] = _withModifiers(() => {}, ["stop"]))
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: "cdr-ap-fill",
                                                                style: _normalizeStyle({ width: _unref(audioProgress)(att.id) + '%' })
                                                              }, null, 4),
                                                              _createElementVNode("input", {
                                                                type: "range",
                                                                class: "cdr-ap-seek",
                                                                min: "0",
                                                                max: "100",
                                                                step: "0.1",
                                                                value: _unref(audioProgress)(att.id),
                                                                onInput: ($event: any) => (_unref(seekAudio)(att, $event))
                                                              }, null, 40, _hoisted_190)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_191, [
                                                              _createElementVNode("span", null, _toDisplayString(_unref(fmtTime)(_unref(audioState)[att.id]?.current || 0)), 1),
                                                              _createElementVNode("span", null, _toDisplayString(_unref(fmtTime)(_unref(audioState)[att.id]?.duration || 0)), 1)
                                                            ])
                                                          ]),
                                                          _createElementVNode("a", {
                                                            href: att.data_url,
                                                            target: "_blank",
                                                            rel: "noopener",
                                                            class: "cdr-ap-dl",
                                                            title: "Baixar"
                                                          }, [...(_cache[165] || (_cache[165] = [
                                                            _createElementVNode("svg", {
                                                              width: "13",
                                                              height: "13",
                                                              viewBox: "0 0 24 24",
                                                              fill: "none",
                                                              stroke: "currentColor",
                                                              "stroke-width": "2.5",
                                                              "stroke-linecap": "round",
                                                              "stroke-linejoin": "round"
                                                            }, [
                                                              _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                                                              _createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
                                                              _createElementVNode("line", {
                                                                x1: "12",
                                                                y1: "15",
                                                                x2: "12",
                                                                y2: "3"
                                                              })
                                                            ], -1)
                                                          ]))], 8, _hoisted_192)
                                                        ]))
                                                      : (_unref(isVideo)(att))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                                                            _createElementVNode("video", {
                                                              src: att.data_url,
                                                              controls: "",
                                                              preload: "metadata",
                                                              class: "cdr-att-video"
                                                            }, null, 8, _hoisted_194)
                                                          ]))
                                                        : (_unref(isPdf)(att))
                                                          ? (_openBlock(), _createElementBlock("a", {
                                                              key: 3,
                                                              href: att.data_url,
                                                              target: "_blank",
                                                              rel: "noopener",
                                                              class: "cdr-att-file cdr-att-pdf"
                                                            }, [
                                                              _cache[167] || (_cache[167] = _createElementVNode("svg", {
                                                                width: "18",
                                                                height: "18",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                "stroke-width": "1.8",
                                                                "stroke-linecap": "round",
                                                                "stroke-linejoin": "round"
                                                              }, [
                                                                _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
                                                                _createElementVNode("polyline", { points: "14 2 14 8 20 8" }),
                                                                _createElementVNode("line", {
                                                                  x1: "16",
                                                                  y1: "13",
                                                                  x2: "8",
                                                                  y2: "13"
                                                                }),
                                                                _createElementVNode("line", {
                                                                  x1: "16",
                                                                  y1: "17",
                                                                  x2: "8",
                                                                  y2: "17"
                                                                })
                                                              ], -1)),
                                                              _createElementVNode("div", _hoisted_196, [
                                                                _cache[166] || (_cache[166] = _createElementVNode("span", { class: "cdr-att-file-ext" }, "PDF", -1)),
                                                                _createElementVNode("span", _hoisted_197, _toDisplayString(_unref(fmtSize)(att.file_size)), 1)
                                                              ]),
                                                              _cache[168] || (_cache[168] = _createElementVNode("svg", {
                                                                width: "13",
                                                                height: "13",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                "stroke-width": "2.5",
                                                                "stroke-linecap": "round",
                                                                "stroke-linejoin": "round"
                                                              }, [
                                                                _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                                                                _createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
                                                                _createElementVNode("line", {
                                                                  x1: "12",
                                                                  y1: "15",
                                                                  x2: "12",
                                                                  y2: "3"
                                                                })
                                                              ], -1))
                                                            ], 8, _hoisted_195))
                                                          : (_openBlock(), _createElementBlock("a", {
                                                              key: 4,
                                                              href: att.data_url,
                                                              target: "_blank",
                                                              rel: "noopener",
                                                              class: "cdr-att-file"
                                                            }, [
                                                              _cache[169] || (_cache[169] = _createElementVNode("svg", {
                                                                width: "16",
                                                                height: "16",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                "stroke-width": "2",
                                                                "stroke-linecap": "round",
                                                                "stroke-linejoin": "round"
                                                              }, [
                                                                _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
                                                                _createElementVNode("polyline", { points: "14 2 14 8 20 8" })
                                                              ], -1)),
                                                              _createElementVNode("div", _hoisted_199, [
                                                                _createElementVNode("span", _hoisted_200, _toDisplayString(att.extension?.toUpperCase() || 'Arquivo'), 1),
                                                                _createElementVNode("span", _hoisted_201, _toDisplayString(_unref(fmtSize)(att.file_size)), 1)
                                                              ]),
                                                              _cache[170] || (_cache[170] = _createElementVNode("svg", {
                                                                width: "13",
                                                                height: "13",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                "stroke-width": "2.5",
                                                                "stroke-linecap": "round",
                                                                "stroke-linejoin": "round"
                                                              }, [
                                                                _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                                                                _createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
                                                                _createElementVNode("line", {
                                                                  x1: "12",
                                                                  y1: "15",
                                                                  x2: "12",
                                                                  y2: "3"
                                                                })
                                                              ], -1))
                                                            ], 8, _hoisted_198))
                                                ]))
                                              }), 128))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("span", _hoisted_202, [
                                            _createTextVNode(_toDisplayString(fmtTs(msg.created_at)) + " ", 1),
                                            (msg.message_type === 1)
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 0,
                                                  class: _normalizeClass(["cdr-msg-status", 's-'+(msg.status||'sent')]),
                                                  title: msg.status === 'read' ? 'Lido' : msg.status === 'delivered' ? 'Entregue' : msg.status === 'failed' ? 'Falhou' : 'Enviado'
                                                }, [
                                                  (msg.status === 'failed')
                                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_204, [...(_cache[171] || (_cache[171] = [
                                                        _createElementVNode("line", {
                                                          x1: "1",
                                                          y1: "1",
                                                          x2: "7",
                                                          y2: "7"
                                                        }, null, -1),
                                                        _createElementVNode("line", {
                                                          x1: "7",
                                                          y1: "1",
                                                          x2: "1",
                                                          y2: "7"
                                                        }, null, -1)
                                                      ]))]))
                                                    : (msg.status === 'read' || msg.status === 'delivered')
                                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_205, [...(_cache[172] || (_cache[172] = [
                                                          _createElementVNode("polyline", { points: "1,4 3.5,6.5 9,1" }, null, -1),
                                                          _createElementVNode("polyline", { points: "5,4 7.5,6.5 13,1" }, null, -1)
                                                        ]))]))
                                                      : (_openBlock(), _createElementBlock("svg", _hoisted_206, [...(_cache[173] || (_cache[173] = [
                                                          _createElementVNode("polyline", { points: "1,4 3.5,6.5 9,1" }, null, -1)
                                                        ]))]))
                                                ], 10, _hoisted_203))
                                              : _createCommentVNode("", true)
                                          ])
                                        ], 2)
                                      ], 64))
                                ], 10, _hoisted_174))
                              }), 128))
                            ], 64))
                      ], 544), [
                        [_vShow, !cdrMacroPanelOpen.value]
                      ]),
                      (files.value.length && !cdrMacroPanelOpen.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_207, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (f, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "cdr-file-pill"
                              }, [
                                _cache[174] || (_cache[174] = _createElementVNode("svg", {
                                  width: "10",
                                  height: "10",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("path", { d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" })
                                ], -1)),
                                _createElementVNode("span", _hoisted_208, _toDisplayString(f.name), 1),
                                _createElementVNode("button", {
                                  class: "cdr-file-rm",
                                  onClick: ($event: any) => (files.value.splice(i, 1))
                                }, "×", 8, _hoisted_209)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (!_unref(recording) && !_unref(recordedBlob) && !videoRecording.value && !videoRecordedBlob.value && !cdrMacroPanelOpen.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 5,
                            class: _normalizeClass(["cdr-composer", { 'cdr-composer--priv': notaInterna.value }])
                          }, [
                            _createElementVNode("label", {
                              class: _normalizeClass(["cdr-attach-btn", { 'cdr-attach-disabled': _unref(cdrWindowClosed) || notaInterna.value }]),
                              title: "Anexar arquivo"
                            }, [
                              _createElementVNode("input", {
                                type: "file",
                                multiple: "",
                                hidden: "",
                                ref_key: "fileInputEl",
                                ref: fileInputEl,
                                disabled: _unref(cdrWindowClosed) || notaInterna.value,
                                onChange: onFilePick
                              }, null, 40, _hoisted_210),
                              _cache[175] || (_cache[175] = _createElementVNode("svg", {
                                width: "15",
                                height: "15",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" })
                              ], -1))
                            ], 2),
                            (_unref(can)('messages.privateNote'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["cdr-priv-btn", { 'cdr-priv-btn--active': notaInterna.value }]),
                                  disabled: _unref(cdrWindowClosed),
                                  onClick: _cache[52] || (_cache[52] = ($event: any) => (notaInterna.value = !notaInterna.value)),
                                  title: notaInterna.value ? 'Nota interna ativada — clique para voltar ao modo normal' : 'Marcar como nota interna (não visível pro cliente)'
                                }, [...(_cache[176] || (_cache[176] = [
                                  _createElementVNode("svg", {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("rect", {
                                      x: "3",
                                      y: "11",
                                      width: "18",
                                      height: "11",
                                      rx: "2"
                                    }),
                                    _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
                                  ], -1)
                                ]))], 10, _hoisted_211))
                              : _createCommentVNode("", true),
                            (!_unref(cdrWindowClosed))
                              ? (_openBlock(), _createBlock(EmojiPicker, {
                                  key: 1,
                                  onPick: insertEmoji
                                }))
                              : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("textarea", {
                              ref_key: "taEl",
                              ref: taEl,
                              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((draft).value = $event)),
                              class: "cdr-ta",
                              placeholder: notaInterna.value ? 'Nota interna — só a equipe vê… (Enter envia)' : (_unref(cdrWindowClosed) ? 'Envie um template para responder…' : 'Mensagem… (Enter envia)'),
                              disabled: _unref(cdrWindowClosed),
                              rows: "1",
                              onKeydown: _cache[54] || (_cache[54] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_unref(sendMsg) && _unref(sendMsg)(...args)), ["exact","prevent"]), ["enter"])),
                              onInput: growTa
                            }, null, 40, _hoisted_212), [
                              [_vModelText, draft.value]
                            ]),
                            (!notaInterna.value && (_unref(cdrWindowClosed) || (!canSend.value && !_unref(sending))))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  (_unref(can)('messages.sendTemplate'))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "cdr-wa-tpl-btn",
                                        onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_unref(openCdrTplModal) && _unref(openCdrTplModal)(...args))),
                                        title: "Enviar template WhatsApp"
                                      }, [...(_cache[177] || (_cache[177] = [
                                        _createElementVNode("svg", {
                                          width: "15",
                                          height: "15",
                                          viewBox: "0 0 24 24",
                                          fill: "currentColor"
                                        }, [
                                          _createElementVNode("path", { d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zm-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884zm8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" })
                                        ], -1)
                                      ]))]))
                                    : _createCommentVNode("", true),
                                  (!_unref(cdrWindowClosed))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("button", {
                                          class: "cdr-mic-btn",
                                          onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_unref(startRecording) && _unref(startRecording)(...args))),
                                          title: "Gravar áudio"
                                        }, [...(_cache[178] || (_cache[178] = [
                                          _createElementVNode("svg", {
                                            width: "14",
                                            height: "14",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            "stroke-width": "2.2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                          }, [
                                            _createElementVNode("path", { d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" }),
                                            _createElementVNode("path", { d: "M19 10v2a7 7 0 0 1-14 0v-2" }),
                                            _createElementVNode("line", {
                                              x1: "12",
                                              y1: "19",
                                              x2: "12",
                                              y2: "23"
                                            }),
                                            _createElementVNode("line", {
                                              x1: "8",
                                              y1: "23",
                                              x2: "16",
                                              y2: "23"
                                            })
                                          ], -1)
                                        ]))]),
                                        _createElementVNode("button", {
                                          class: "cdr-mic-btn",
                                          onClick: startVideoRecording,
                                          title: "Gravar vídeo"
                                        }, [...(_cache[179] || (_cache[179] = [
                                          _createElementVNode("svg", {
                                            width: "14",
                                            height: "14",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                          }, [
                                            _createElementVNode("polygon", { points: "23 7 16 12 23 17 23 7" }),
                                            _createElementVNode("rect", {
                                              x: "1",
                                              y: "5",
                                              width: "15",
                                              height: "14",
                                              rx: "2",
                                              ry: "2"
                                            })
                                          ], -1)
                                        ]))])
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 3,
                                  class: "cdr-send-btn",
                                  onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_unref(sendMsg) && _unref(sendMsg)(...args))),
                                  disabled: !canSend.value || _unref(sending)
                                }, [
                                  (_unref(sending))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_214))
                                    : (_openBlock(), _createElementBlock("svg", _hoisted_215, [...(_cache[180] || (_cache[180] = [
                                        _createElementVNode("line", {
                                          x1: "22",
                                          y1: "2",
                                          x2: "11",
                                          y2: "13"
                                        }, null, -1),
                                        _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" }, null, -1)
                                      ]))]))
                                ], 8, _hoisted_213))
                          ], 2))
                        : (_unref(recording) && !cdrMacroPanelOpen.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_216, [
                              _createElementVNode("button", {
                                class: "cdr-rec-cancel",
                                onClick: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_unref(cancelRecording) && _unref(cancelRecording)(...args))),
                                title: "Cancelar gravação"
                              }, [...(_cache[181] || (_cache[181] = [
                                _createElementVNode("svg", {
                                  width: "13",
                                  height: "13",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "3",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("line", {
                                    x1: "18",
                                    y1: "6",
                                    x2: "6",
                                    y2: "18"
                                  }),
                                  _createElementVNode("line", {
                                    x1: "6",
                                    y1: "6",
                                    x2: "18",
                                    y2: "18"
                                  })
                                ], -1)
                              ]))]),
                              _cache[183] || (_cache[183] = _createElementVNode("span", { class: "cdr-rec-dot" }, null, -1)),
                              _createElementVNode("div", _hoisted_217, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(waveformBars), (h, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: i,
                                    class: "cdr-rec-bar",
                                    style: _normalizeStyle({ height: h + 'px' })
                                  }, null, 4))
                                }), 128))
                              ]),
                              _createElementVNode("span", _hoisted_218, _toDisplayString(_unref(fmtRecordingTime)(_unref(recordingTime))), 1),
                              _createElementVNode("button", {
                                class: "cdr-rec-stop",
                                onClick: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_unref(stopRecording) && _unref(stopRecording)(...args))),
                                title: "Parar e revisar"
                              }, [...(_cache[182] || (_cache[182] = [
                                _createElementVNode("svg", {
                                  width: "14",
                                  height: "14",
                                  viewBox: "0 0 24 24",
                                  fill: "currentColor"
                                }, [
                                  _createElementVNode("rect", {
                                    x: "4",
                                    y: "4",
                                    width: "16",
                                    height: "16",
                                    rx: "2"
                                  })
                                ], -1)
                              ]))])
                            ]))
                          : (_unref(recordedBlob) && !cdrMacroPanelOpen.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_219, [
                                _createElementVNode("button", {
                                  class: "cdr-rec-cancel",
                                  onClick: _cache[60] || (_cache[60] = 
//@ts-ignore
(...args) => (_unref(cancelRecording) && _unref(cancelRecording)(...args))),
                                  title: "Descartar"
                                }, [...(_cache[184] || (_cache[184] = [
                                  _createElementVNode("svg", {
                                    width: "13",
                                    height: "13",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "3",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("line", {
                                      x1: "18",
                                      y1: "6",
                                      x2: "6",
                                      y2: "18"
                                    }),
                                    _createElementVNode("line", {
                                      x1: "6",
                                      y1: "6",
                                      x2: "18",
                                      y2: "18"
                                    })
                                  ], -1)
                                ]))]),
                                _createElementVNode("audio", {
                                  src: _unref(recordedUrl),
                                  controls: "",
                                  preload: "auto",
                                  class: "cdr-rec-audio"
                                }, null, 8, _hoisted_220),
                                _createElementVNode("button", {
                                  class: "cdr-rec-send",
                                  onClick: _cache[61] || (_cache[61] = 
//@ts-ignore
(...args) => (_unref(sendRecordedAudio) && _unref(sendRecordedAudio)(...args))),
                                  title: "Enviar áudio"
                                }, [...(_cache[185] || (_cache[185] = [
                                  _createElementVNode("svg", {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  }, [
                                    _createElementVNode("line", {
                                      x1: "22",
                                      y1: "2",
                                      x2: "11",
                                      y2: "13"
                                    }),
                                    _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })
                                  ], -1)
                                ]))])
                              ]))
                            : (videoRecording.value && !cdrMacroPanelOpen.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
                                  _createElementVNode("video", {
                                    ref_key: "videoPreviewEl",
                                    ref: videoPreviewEl,
                                    muted: "",
                                    autoplay: "",
                                    playsinline: "",
                                    class: "cdr-vrec-preview"
                                  }, null, 512),
                                  _createElementVNode("div", _hoisted_222, [
                                    _createElementVNode("button", {
                                      class: "cdr-rec-cancel",
                                      onClick: cancelVideoRecording,
                                      title: "Cancelar gravação"
                                    }, [...(_cache[186] || (_cache[186] = [
                                      _createElementVNode("svg", {
                                        width: "13",
                                        height: "13",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "3",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                      }, [
                                        _createElementVNode("line", {
                                          x1: "18",
                                          y1: "6",
                                          x2: "6",
                                          y2: "18"
                                        }),
                                        _createElementVNode("line", {
                                          x1: "6",
                                          y1: "6",
                                          x2: "18",
                                          y2: "18"
                                        })
                                      ], -1)
                                    ]))]),
                                    _cache[188] || (_cache[188] = _createElementVNode("span", { class: "cdr-rec-dot" }, null, -1)),
                                    _createElementVNode("span", _hoisted_223, _toDisplayString(_unref(fmtRecordingTime)(videoRecordingTime.value)), 1),
                                    _createElementVNode("button", {
                                      class: "cdr-rec-stop",
                                      onClick: stopVideoRecording,
                                      title: "Parar e revisar"
                                    }, [...(_cache[187] || (_cache[187] = [
                                      _createElementVNode("svg", {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 24 24",
                                        fill: "currentColor"
                                      }, [
                                        _createElementVNode("rect", {
                                          x: "4",
                                          y: "4",
                                          width: "16",
                                          height: "16",
                                          rx: "2"
                                        })
                                      ], -1)
                                    ]))])
                                  ])
                                ]))
                              : (videoRecordedBlob.value && !cdrMacroPanelOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                                    _createElementVNode("video", {
                                      src: videoRecordedUrl.value,
                                      controls: "",
                                      preload: "auto",
                                      class: "cdr-vrec-preview"
                                    }, null, 8, _hoisted_225),
                                    _createElementVNode("div", { class: "cdr-vrec-bar" }, [
                                      _createElementVNode("button", {
                                        class: "cdr-rec-cancel",
                                        onClick: cancelVideoRecording,
                                        title: "Descartar"
                                      }, [...(_cache[189] || (_cache[189] = [
                                        _createElementVNode("svg", {
                                          width: "13",
                                          height: "13",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "3",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, [
                                          _createElementVNode("line", {
                                            x1: "18",
                                            y1: "6",
                                            x2: "6",
                                            y2: "18"
                                          }),
                                          _createElementVNode("line", {
                                            x1: "6",
                                            y1: "6",
                                            x2: "18",
                                            y2: "18"
                                          })
                                        ], -1)
                                      ]))]),
                                      _cache[191] || (_cache[191] = _createElementVNode("span", { style: {"flex":"1","font-size":"12px","color":"#6b7280"} }, "Pronto para enviar", -1)),
                                      _createElementVNode("button", {
                                        class: "cdr-rec-send",
                                        onClick: sendRecordedVideo,
                                        title: "Enviar vídeo"
                                      }, [...(_cache[190] || (_cache[190] = [
                                        _createElementVNode("svg", {
                                          width: "14",
                                          height: "14",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.5",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, [
                                          _createElementVNode("line", {
                                            x1: "22",
                                            y1: "2",
                                            x2: "11",
                                            y2: "13"
                                          }),
                                          _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })
                                        ], -1)
                                      ]))])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_unref(cdrTplOpen))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "cdr-tpl-overlay",
            onMousedown: _cache[67] || (_cache[67] = _withModifiers(
//@ts-ignore
(...args) => (_unref(closeCdrTplModal) && _unref(closeCdrTplModal)(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_226, [
              _createElementVNode("div", _hoisted_227, [
                _createElementVNode("div", _hoisted_228, [
                  _cache[192] || (_cache[192] = _createElementVNode("svg", {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 24 24",
                    fill: "#25D366"
                  }, [
                    _createElementVNode("path", { d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zm-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884zm8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" })
                  ], -1)),
                  _cache[193] || (_cache[193] = _createTextVNode(" Enviar Template WhatsApp ", -1)),
                  _createElementVNode("span", _hoisted_229, "→ " + _toDisplayString(activeConv.value?.contact.name), 1)
                ]),
                _createElementVNode("button", {
                  class: "cdr-tpl-close",
                  onClick: _cache[62] || (_cache[62] = 
//@ts-ignore
(...args) => (_unref(closeCdrTplModal) && _unref(closeCdrTplModal)(...args)))
                }, [...(_cache[194] || (_cache[194] = [
                  _createElementVNode("svg", {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5"
                  }, [
                    _createElementVNode("path", { d: "M18 6 6 18M6 6l12 12" })
                  ], -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_230, [
                _createElementVNode("div", _hoisted_231, [
                  _cache[196] || (_cache[196] = _createElementVNode("div", { class: "cdr-tpl-col-lbl" }, "Templates aprovados", -1)),
                  (_unref(cdrTplsLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_232, [...(_cache[195] || (_cache[195] = [
                        _createElementVNode("span", { class: "cdr-tpl-spin" }, null, -1),
                        _createTextVNode(" Carregando…", -1)
                      ]))]))
                    : (!_unref(cdrTplsApproved).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_233, "Nenhum template aprovado"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_234, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cdrTplsApproved), (t) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: t.id,
                              class: _normalizeClass(["cdr-tpl-item", { active: _unref(cdrTplSel)?.id === t.id }]),
                              onClick: ($event: any) => (_unref(selectCdrTpl)(t))
                            }, [
                              _createElementVNode("div", _hoisted_236, _toDisplayString(t.name.replace(/_/g,' ')), 1),
                              _createElementVNode("div", _hoisted_237, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["cdr-tpl-cat", t.category.toLowerCase()])
                                }, _toDisplayString(t.category === 'MARKETING' ? 'Marketing' : 'Utilidade'), 3),
                                _createElementVNode("span", _hoisted_238, _toDisplayString(t.language), 1)
                              ])
                            ], 10, _hoisted_235))
                          }), 128))
                        ]))
                ]),
                _createElementVNode("div", _hoisted_239, [
                  (!_unref(cdrTplSel))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_240, [...(_cache[197] || (_cache[197] = [
                        _createElementVNode("svg", {
                          width: "28",
                          height: "28",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "1.5"
                        }, [
                          _createElementVNode("path", { d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" }),
                          _createElementVNode("rect", {
                            x: "9",
                            y: "3",
                            width: "6",
                            height: "4",
                            rx: "1"
                          })
                        ], -1),
                        _createElementVNode("span", null, "Selecione um template ao lado", -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[204] || (_cache[204] = _createElementVNode("div", {
                          class: "cdr-tpl-col-lbl",
                          style: {"margin-bottom":"8px"}
                        }, "Preview em tempo real", -1)),
                        _createElementVNode("div", _hoisted_241, [
                          _createElementVNode("div", _hoisted_242, [
                            (_unref(cdrTplHasImg))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                                  (_unref(cdrTplImgUrl) && !_unref(cdrTplImgErr))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _unref(cdrTplImgUrl),
                                        alt: "",
                                        onError: _cache[63] || (_cache[63] = ($event: any) => (cdrTplImgErr.value = true))
                                      }, null, 40, _hoisted_244))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_245, [...(_cache[198] || (_cache[198] = [
                                        _createElementVNode("svg", {
                                          width: "22",
                                          height: "22",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "1.5"
                                        }, [
                                          _createElementVNode("rect", {
                                            x: "3",
                                            y: "3",
                                            width: "18",
                                            height: "18",
                                            rx: "2"
                                          }),
                                          _createElementVNode("circle", {
                                            cx: "8.5",
                                            cy: "8.5",
                                            r: "1.5"
                                          }),
                                          _createElementVNode("path", { d: "M21 15l-5-5L5 21" })
                                        ], -1)
                                      ]))]))
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(cdrTplHeaderTxt))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_246, _toDisplayString(_unref(cdrTplHeaderTxt)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: "cdr-tpl-bubble-body",
                              innerHTML: _unref(cdrTplPreviewHtml)
                            }, null, 8, _hoisted_247),
                            (_unref(cdrTplFooterTxt))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_248, _toDisplayString(_unref(cdrTplFooterTxt)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_249, _toDisplayString(_unref(cdrTplTime)), 1)
                          ]),
                          (_unref(cdrTplButtons).length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_250, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cdrTplButtons), (b, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: i,
                                    class: "cdr-tpl-btn"
                                  }, _toDisplayString(b.text || 'Botão'), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_unref(cdrTplHasImg))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_251, [
                              _cache[199] || (_cache[199] = _createElementVNode("div", { class: "cdr-tpl-field-lbl" }, "URL da imagem", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "url",
                                class: "cdr-tpl-input",
                                "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => (_isRef(cdrTplImgUrl) ? (cdrTplImgUrl).value = $event : null)),
                                placeholder: "https://…",
                                onInput: _cache[65] || (_cache[65] = ($event: any) => (cdrTplImgErr.value = false))
                              }, null, 544), [
                                [_vModelText, _unref(cdrTplImgUrl)]
                              ]),
                              _cache[200] || (_cache[200] = _createElementVNode("div", { class: "cdr-tpl-hint" }, "Use uma URL pública permanente", -1))
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(cdrTplVarNums).length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                              _cache[202] || (_cache[202] = _createElementVNode("div", {
                                class: "cdr-tpl-col-lbl",
                                style: {"margin-bottom":"6px"}
                              }, "Variáveis", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cdrTplVarNums), (n) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: n,
                                  style: {"margin-bottom":"7px"}
                                }, [
                                  _createElementVNode("div", _hoisted_253, "Variável {{" + _toDisplayString(n) + "}}", 1),
                                  (_unref(cdrTplVarMapping)[n])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_254, [
                                        _cache[201] || (_cache[201] = _createElementVNode("svg", {
                                          width: "12",
                                          height: "12",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.5",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, [
                                          _createElementVNode("path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
                                          _createElementVNode("path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })
                                        ], -1)),
                                        _createTextVNode(" Preenchido automaticamente: " + _toDisplayString(_unref(cdrMappedLabel)(n)), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("input", {
                                        key: 1,
                                        type: "text",
                                        class: "cdr-tpl-input",
                                        placeholder: `Valor para {{${n}}}`,
                                        value: _unref(cdrTplVars)[n] || '',
                                        onInput: ($event: any) => (_unref(setCdrTplVar)(n, ($event.target as HTMLInputElement).value))
                                      }, null, 40, _hoisted_255))
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_256, [
                          (_unref(cdrTplSendBlocked))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_257, _toDisplayString(_unref(cdrTplSendBlockedReason)), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "cdr-tpl-send-btn",
                            disabled: _unref(cdrTplSending) || _unref(cdrTplSendBlocked),
                            title: _unref(cdrTplSendBlockedReason),
                            onClick: _cache[66] || (_cache[66] = 
//@ts-ignore
(...args) => (_unref(sendCdrTpl) && _unref(sendCdrTpl)(...args)))
                          }, [
                            (!_unref(cdrTplSending))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_259, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_260, [...(_cache[203] || (_cache[203] = [
                                    _createElementVNode("line", {
                                      x1: "22",
                                      y1: "2",
                                      x2: "11",
                                      y2: "13"
                                    }, null, -1),
                                    _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" }, null, -1)
                                  ]))])),
                                  _createTextVNode(" Enviar para " + _toDisplayString(activeConv.value?.contact.name), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_261))
                          ], 8, _hoisted_258)
                        ])
                      ], 64))
                ])
              ])
            ])
          ], 32))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})